// GENERATED FILE - do not edit by hand.
// Produced by scripts/buildCardData.mjs from scripts/source-data/*.js.
// Re-run "node scripts/buildCardData.mjs" after changing the source data.

export const cardDefinitions = [
  {
    "id": "hero-aeon-l1",
    "type": "hero",
    "subtype": null,
    "title": "Lesser Aeon Priest",
    "traits": [
      "Human",
      "Thief",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "aeon"
  },
  {
    "id": "hero-aeon-l2",
    "type": "hero",
    "subtype": null,
    "title": "Aeon Priest",
    "traits": [
      "Human",
      "Thief",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 1,
    "strength": 4,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 card. You may place 1 card of up to 2 higher cost from the village into your discard pile.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 card. You may place 1 card of up to 2 higher cost from the village into your discard pile.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "aeon"
  },
  {
    "id": "hero-aeon-l3",
    "type": "hero",
    "subtype": null,
    "title": "Greater Aeon Priest",
    "traits": [
      "Human",
      "Thief",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 1,
    "strength": 4,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 card. You may place 1 card of up to 2 higher cost from the village into your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "aeon"
  },
  {
    "id": "hero-aird-l1",
    "type": "hero",
    "subtype": null,
    "title": "Aird Cutpurse",
    "traits": [
      "Human",
      "Thief",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "All players discard the top card of their deck. Gain the gold value of one discarded card.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "aird"
  },
  {
    "id": "hero-aird-l2",
    "type": "hero",
    "subtype": null,
    "title": "Aird Honeytongue",
    "traits": [
      "Human",
      "Thief",
      "Level 2"
    ],
    "goldValue": 2,
    "strength": 3,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "All players discard the top card of their deck. Gain the gold value of one discarded card. Gain Physical Attack equal to the gold value of one discarded card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "aird"
  },
  {
    "id": "hero-aird-l3",
    "type": "hero",
    "subtype": null,
    "title": "Aird Seductress",
    "traits": [
      "Human",
      "Thief",
      "Level 3"
    ],
    "goldValue": 3,
    "strength": 4,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "All other players show their hands. Add one revealed hero to your hand. Return that hero to its owner's discard pile after the combat (even if it was destroyed).",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "aird"
  },
  {
    "id": "hero-armsman-l1",
    "type": "hero",
    "subtype": null,
    "title": "Armsman Bastion",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "armsman"
  },
  {
    "id": "hero-armsman-l2",
    "type": "hero",
    "subtype": null,
    "title": "Armsman Stronghold",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Buy 1 weapon and place it into your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "armsman"
  },
  {
    "id": "hero-armsman-l3",
    "type": "hero",
    "subtype": null,
    "title": "Armsman Citadel",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Place 1 weapon from a village stack into your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "armsman"
  },
  {
    "id": "hero-bhoidwood-l1",
    "type": "hero",
    "subtype": null,
    "title": "Bhoidwood Hunter",
    "traits": [
      "Elf",
      "Ranger",
      "Level 1"
    ],
    "goldValue": -1,
    "strength": 5,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bhoidwood"
  },
  {
    "id": "hero-bhoidwood-l2",
    "type": "hero",
    "subtype": null,
    "title": "Bhoidwood Stalker",
    "traits": [
      "Elf",
      "Ranger",
      "Level 2"
    ],
    "goldValue": -2,
    "strength": 5,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Switch the positions of two adjacent monsters in the hall.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bhoidwood"
  },
  {
    "id": "hero-bhoidwood-l3",
    "type": "hero",
    "subtype": null,
    "title": "Bhoidwood Slayer",
    "traits": [
      "Elf",
      "Ranger",
      "Level 3"
    ],
    "goldValue": -3,
    "strength": 6,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +6",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Rearrange the hall.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bhoidwood"
  },
  {
    "id": "hero-blackhand-l1",
    "type": "hero",
    "subtype": null,
    "title": "Blackhand Smuggler",
    "traits": [
      "Human",
      "Thief",
      "Level 1"
    ],
    "goldValue": 2,
    "strength": 3,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        },
        {
          "text": "If you purchase a hero or villager this turn, you may place it on top of your deck instead of in your discard pile.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blackhand"
  },
  {
    "id": "hero-blackhand-l2",
    "type": "hero",
    "subtype": null,
    "title": "Blackhand Thief",
    "traits": [
      "Human",
      "Thief",
      "Level 2"
    ],
    "goldValue": 2,
    "strength": 4,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +2 if two or more other heroes are present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blackhand"
  },
  {
    "id": "hero-blackhand-l3",
    "type": "hero",
    "subtype": null,
    "title": "Blackhand Assassin",
    "traits": [
      "Human",
      "Thief",
      "Level 3"
    ],
    "goldValue": 3,
    "strength": 4,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +4 if one or more other heroes are present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blackhand"
  },
  {
    "id": "hero-blademage-l1",
    "type": "hero",
    "subtype": null,
    "title": "Blademage Striker",
    "traits": [
      "Human",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 3,
    "light": 1,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blademage"
  },
  {
    "id": "hero-blademage-l2",
    "type": "hero",
    "subtype": null,
    "title": "Blademage Forger",
    "traits": [
      "Human",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 3,
    "light": 1,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "One spell becomes a Weight 0 magic weapon equipped to this hero (it is still a spell) that adds Magic Attack +3.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blademage"
  },
  {
    "id": "hero-blademage-l3",
    "type": "hero",
    "subtype": null,
    "title": "Blademage Caster",
    "traits": [
      "Human",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 3,
    "light": 1,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Each spell becomes a Weight 0 magic weapon (each is still a spell) that adds Magic Attack equal to its gold cost.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blademage"
  },
  {
    "id": "hero-blind-l1",
    "type": "hero",
    "subtype": null,
    "title": "Blind Neophyte",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 Light item to add Magic Attack +3.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blind"
  },
  {
    "id": "hero-blind-l2",
    "type": "hero",
    "subtype": null,
    "title": "Blind Monk",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 Light item to add Magic Attack +4.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blind"
  },
  {
    "id": "hero-blind-l3",
    "type": "hero",
    "subtype": null,
    "title": "Blind Grandmaster",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 3,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Ignore Darkness penalties.",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +3 if no Light items are present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blind"
  },
  {
    "id": "hero-blind-l4",
    "type": "hero",
    "subtype": null,
    "title": "Blind Shihan",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 16,
    "level": 4,
    "xp": 0,
    "points": 5,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        },
        {
          "text": "Ignore Darkness penalties.",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +4 and ignore Battle effects if no Light items are present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "blind"
  },
  {
    "id": "hero-bluefire-l1",
    "type": "hero",
    "subtype": null,
    "title": "Bluefire Student",
    "traits": [
      "Human",
      "Cleric",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 2,
    "cost": 4,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Gain 1 XP.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bluefire"
  },
  {
    "id": "hero-bluefire-l2",
    "type": "hero",
    "subtype": null,
    "title": "Bluefire Mage",
    "traits": [
      "Human",
      "Cleric",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 7,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Gain 2 XP.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bluefire"
  },
  {
    "id": "hero-bluefire-l3",
    "type": "hero",
    "subtype": null,
    "title": "Bluefire Master",
    "traits": [
      "Human",
      "Cleric",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 10,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Level up 1 hero (pay all costs). Place the new hero in your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bluefire"
  },
  {
    "id": "hero-bluefire-l4",
    "type": "hero",
    "subtype": null,
    "title": "Bluefire Preceptor",
    "traits": [
      "Human",
      "Cleric",
      "Wizard",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 14,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Level up 1 hero (pay all costs). Place the new hero in your hand. Instead of destroying the hero you level with this ability, you may return it to your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bluefire"
  },
  {
    "id": "hero-caliginite-l1",
    "type": "hero",
    "subtype": null,
    "title": "Caliginite Lurker",
    "traits": [
      "Dwarf",
      "Thief",
      "Level 1"
    ],
    "goldValue": 1,
    "strength": 4,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +2 if there is Darkness.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "caliginite"
  },
  {
    "id": "hero-caliginite-l2",
    "type": "hero",
    "subtype": null,
    "title": "Caliginite Prowler",
    "traits": [
      "Dwarf",
      "Thief",
      "Level 2"
    ],
    "goldValue": 1,
    "strength": 4,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +3 if there is Darkness.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "caliginite"
  },
  {
    "id": "hero-caliginite-l3",
    "type": "hero",
    "subtype": null,
    "title": "Caliginite Silencer",
    "traits": [
      "Dwarf",
      "Thief",
      "Level 3"
    ],
    "goldValue": 1,
    "strength": 5,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +6 if there is Darkness.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "caliginite"
  },
  {
    "id": "hero-cathedral-l1",
    "type": "hero",
    "subtype": null,
    "title": "Cathedral Acolyte",
    "traits": [
      "Human",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "cathedral"
  },
  {
    "id": "hero-cathedral-l2",
    "type": "hero",
    "subtype": null,
    "title": "Cathedral Priest",
    "traits": [
      "Human",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 card to draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 card to draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "cathedral"
  },
  {
    "id": "hero-cathedral-l3",
    "type": "hero",
    "subtype": null,
    "title": "Cathedral Bishop",
    "traits": [
      "Human",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 card to add Magic Attack +3 to this card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "cathedral"
  },
  {
    "id": "hero-chalice-l1",
    "type": "hero",
    "subtype": null,
    "title": "Chalice Quester",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "chalice"
  },
  {
    "id": "hero-chalice-l2",
    "type": "hero",
    "subtype": null,
    "title": "Chalice Defender",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 for each Light item present.",
          "repeatable": false
        },
        {
          "text": "Draw 1 card.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "chalice"
  },
  {
    "id": "hero-chalice-l3",
    "type": "hero",
    "subtype": null,
    "title": "Chalice Paladin",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 card.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "chalice"
  },
  {
    "id": "hero-chalice-l4",
    "type": "hero",
    "subtype": null,
    "title": "Chalice Paragon",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 16,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 2 cards. If either has a Light icon, you may draw 2 more cards.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 card. If it has a Light icon, you may buy 1 additional card.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "chalice"
  },
  {
    "id": "hero-charming-l1",
    "type": "hero",
    "subtype": null,
    "title": "Charming",
    "traits": [
      "Human",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": true
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "charming"
  },
  {
    "id": "hero-charming-l2",
    "type": "hero",
    "subtype": null,
    "title": "Charming Nano",
    "traits": [
      "Human",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Place one Regular or level 1 hero from your discard pile into your hand.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "charming"
  },
  {
    "id": "hero-charming-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Charming Nano",
    "traits": [
      "Human",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Place 1 hero from your discard pile into your hand.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "charming"
  },
  {
    "id": "hero-clan-l1",
    "type": "hero",
    "subtype": null,
    "title": "Clan Sergeant",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 to each other equipped hero.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "clan"
  },
  {
    "id": "hero-clan-l2",
    "type": "hero",
    "subtype": null,
    "title": "Clan Commander",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +2 to each other equipped hero.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "clan"
  },
  {
    "id": "hero-clan-l3",
    "type": "hero",
    "subtype": null,
    "title": "Clan Champion",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +3 to each other equipped hero.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 weapon.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "clan"
  },
  {
    "id": "hero-clan-l4",
    "type": "hero",
    "subtype": null,
    "title": "Clan King",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 9,
    "cost": 16,
    "level": 4,
    "xp": 0,
    "points": 5,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +4 to each other equipped hero.",
          "repeatable": false
        },
        {
          "text": "If no weapon is present buy 1 weapon and add it to your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "clan"
  },
  {
    "id": "hero-clever-l1",
    "type": "hero",
    "subtype": null,
    "title": "Clever",
    "traits": [
      "Human",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "clever"
  },
  {
    "id": "hero-clever-l2",
    "type": "hero",
    "subtype": null,
    "title": "Clever Nano",
    "traits": [
      "Human",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "This hero can only use one ability.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Magic Attack +3.",
          "repeatable": false
        },
        {
          "text": "Physical Attack equal to the VP of 1 monster present (in your hand). This card becomes unequipped and cannot equip weapons.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "clever"
  },
  {
    "id": "hero-clever-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Clever Nano",
    "traits": [
      "Human",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "This hero can only use one ability.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Magic Attack +5",
          "repeatable": false
        },
        {
          "text": "Physical Attack equal to the Health of 1 monster present (in your hand). This card becomes unequipped and cannot equip weapons.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "clever"
  },
  {
    "id": "hero-criochan-l1",
    "type": "hero",
    "subtype": null,
    "title": "Criochan Sergeant",
    "traits": [
      "Human",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "criochan"
  },
  {
    "id": "hero-criochan-l2",
    "type": "hero",
    "subtype": null,
    "title": "Criochan Knight",
    "traits": [
      "Human",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "criochan"
  },
  {
    "id": "hero-criochan-l3",
    "type": "hero",
    "subtype": null,
    "title": "Criochan Captain",
    "traits": [
      "Human",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +8",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "criochan"
  },
  {
    "id": "hero-dark-l1",
    "type": "hero",
    "subtype": null,
    "title": "Dark Animator",
    "traits": [
      "Human",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 2,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 hero or villager in your discard pile to add Magic Attack +1.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dark"
  },
  {
    "id": "hero-dark-l2",
    "type": "hero",
    "subtype": null,
    "title": "Dark Puppeteer",
    "traits": [
      "Human",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Magic Attack equal to the VP of 1 monster present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dark"
  },
  {
    "id": "hero-dark-l3",
    "type": "hero",
    "subtype": null,
    "title": "Dark Necromancer",
    "traits": [
      "Human",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Magic Attack equal to the total VP of all monsters present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dark"
  },
  {
    "id": "hero-dark-l4",
    "type": "hero",
    "subtype": null,
    "title": "Dark Eternal",
    "traits": [
      "Human",
      "Wizard",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 16,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Magic Attack equal to the total VP of all monsters present or in the top 5 cards of your discard pile.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dark"
  },
  {
    "id": "hero-deepstrider-l1",
    "type": "hero",
    "subtype": null,
    "title": "Deepstrider Sentry",
    "traits": [
      "Elf",
      "Ranger",
      "Level 1"
    ],
    "goldValue": -1,
    "strength": 5,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "deepstrider"
  },
  {
    "id": "hero-deepstrider-l2",
    "type": "hero",
    "subtype": null,
    "title": "Deepstrider Scout",
    "traits": [
      "Elf",
      "Ranger",
      "Level 2"
    ],
    "goldValue": -1,
    "strength": 5,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Reveal the top card of the dungeon deck. Give your heroes Attack +1 against monsters of that group. Place the revealed card on the top and/or bottom of the dungeon deck.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "deepstrider"
  },
  {
    "id": "hero-deepstrider-l3",
    "type": "hero",
    "subtype": null,
    "title": "Deepstrider Warden",
    "traits": [
      "Elf",
      "Ranger",
      "Level 3"
    ],
    "goldValue": -2,
    "strength": 6,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Reveal the top 2 cards of the dungeon deck. Give your heroes Attack +1 against monsters of the revealed groups. Place the revealed cards on the top and/or bottom of the dungeon deck in any order.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "deepstrider"
  },
  {
    "id": "hero-disowned-l1",
    "type": "hero",
    "subtype": null,
    "title": "Disowned Berserker",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 other hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "disowned"
  },
  {
    "id": "hero-disowned-l2",
    "type": "hero",
    "subtype": null,
    "title": "Disowned Reaver",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [
        {
          "text": "If equipped with a weapon, destroy 1 other hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "disowned"
  },
  {
    "id": "hero-disowned-l3",
    "type": "hero",
    "subtype": null,
    "title": "Disowned Bloodrager",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +8",
          "repeatable": false
        },
        {
          "text": "This hero can equip two weapons.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy all other heroes. Place this card on top of your deck.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "disowned"
  },
  {
    "id": "hero-divine-l1",
    "type": "hero",
    "subtype": null,
    "title": "Divine Healer",
    "traits": [
      "Human",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "divine"
  },
  {
    "id": "hero-divine-l2",
    "type": "hero",
    "subtype": null,
    "title": "Divine Chaplain",
    "traits": [
      "Human",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +1 for each disease and monster present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "divine"
  },
  {
    "id": "hero-divine-l3",
    "type": "hero",
    "subtype": null,
    "title": "Divine Prophet",
    "traits": [
      "Human",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 disease to draw 2 cards.",
          "repeatable": false
        },
        {
          "text": "Draw 1 card for each monster present.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 disease to draw 2 cards.",
          "repeatable": false
        },
        {
          "text": "Draw 1 card for each monster present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "divine"
  },
  {
    "id": "hero-divine-l4",
    "type": "hero",
    "subtype": null,
    "title": "Divine Herald",
    "traits": [
      "Human",
      "Cleric",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 15,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 disease to draw 2 cards.",
          "repeatable": false
        },
        {
          "text": "Draw 2 cards for each monster present.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 disease to draw 2 cards.",
          "repeatable": false
        },
        {
          "text": "Draw 2 cards for each monster present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "divine"
  },
  {
    "id": "hero-drua-l1",
    "type": "hero",
    "subtype": null,
    "title": "Drua Sacrist",
    "traits": [
      "Elf",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 card in your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "drua"
  },
  {
    "id": "hero-drua-l2",
    "type": "hero",
    "subtype": null,
    "title": "Drua Cursesworn",
    "traits": [
      "Elf",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 card in your hand.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 card in your hand.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "drua"
  },
  {
    "id": "hero-drua-l3",
    "type": "hero",
    "subtype": null,
    "title": "Drua Purifier",
    "traits": [
      "Elf",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy 1 card in your hand.",
          "repeatable": true
        },
        {
          "text": "Destroy 1 disease to draw 2 cards.",
          "repeatable": true
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 card in your hand.",
          "repeatable": true
        },
        {
          "text": "Destroy 1 disease to draw 2 cards.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "drua"
  },
  {
    "id": "hero-forcemage-l1",
    "type": "hero",
    "subtype": null,
    "title": "Forcemage Shaper",
    "traits": [
      "Human",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 8,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +1 for each spell present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "forcemage"
  },
  {
    "id": "hero-forcemage-l2",
    "type": "hero",
    "subtype": null,
    "title": "Forcemage Evoker",
    "traits": [
      "Human",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 11,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 1 card. If it is a spell, draw an additional card and add Magic Attack +1.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "forcemage"
  },
  {
    "id": "hero-forcemage-l3",
    "type": "hero",
    "subtype": null,
    "title": "Forcemage Blaster",
    "traits": [
      "Human",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 14,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 2 cards. If either is a spell, draw an additional card and add Magic Attack +2.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "forcemage"
  },
  {
    "id": "hero-garrison-l1",
    "type": "hero",
    "subtype": null,
    "title": "Garrison Page",
    "traits": [
      "Human",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "garrison"
  },
  {
    "id": "hero-garrison-l2",
    "type": "hero",
    "subtype": null,
    "title": "Garrison Squire",
    "traits": [
      "Human",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 while equipped with a weapon.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "garrison"
  },
  {
    "id": "hero-garrison-l3",
    "type": "hero",
    "subtype": null,
    "title": "Garrison Knight",
    "traits": [
      "Human",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +3 while equipped with a weapon.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "garrison"
  },
  {
    "id": "hero-glamercast-l1",
    "type": "hero",
    "subtype": null,
    "title": "Glamercast Troubadour",
    "traits": [
      "Human",
      "Thief",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 2,
    "light": 1,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Give each other hero Magic Attack +1.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "glamercast"
  },
  {
    "id": "hero-glamercast-l2",
    "type": "hero",
    "subtype": null,
    "title": "Glamercast Bard",
    "traits": [
      "Human",
      "Thief",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 3,
    "light": 1,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        },
        {
          "text": "Give each other hero Magic Attack +1.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "glamercast"
  },
  {
    "id": "hero-glamercast-l3",
    "type": "hero",
    "subtype": null,
    "title": "Glamercast Maestro",
    "traits": [
      "Human",
      "Thief",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 3,
    "light": 1,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        },
        {
          "text": "Give each other hero Magic Attack +2.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Gain 1 XP per hero.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "glamercast"
  },
  {
    "id": "hero-gohlen-l1",
    "type": "hero",
    "subtype": null,
    "title": "Gohlen Trapper",
    "traits": [
      "Human",
      "Ranger",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +2 if a monster is present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "gohlen"
  },
  {
    "id": "hero-gohlen-l2",
    "type": "hero",
    "subtype": null,
    "title": "Gohlen Tracker",
    "traits": [
      "Human",
      "Ranger",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +3 if a monster is present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "gohlen"
  },
  {
    "id": "hero-gohlen-l3",
    "type": "hero",
    "subtype": null,
    "title": "Gohlen Hunter",
    "traits": [
      "Human",
      "Ranger",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Each other player discards 1 monster or shows a hand with none.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Place 1 discarded monster of 5 VP or lower onto your discard pile if it is from the same group as the monster you defeated.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "gohlen"
  },
  {
    "id": "hero-gohlen-l4",
    "type": "hero",
    "subtype": null,
    "title": "Gohlen Chaser",
    "traits": [
      "Human",
      "Ranger",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 17,
    "level": 4,
    "xp": 0,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Each other player discards 1 monster or shows a hand with none.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Place 1 discarded monster of 5 VP or lower onto your discard pile.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "gohlen"
  },
  {
    "id": "hero-graceful-l1",
    "type": "hero",
    "subtype": null,
    "title": "Graceful",
    "traits": [
      "Human",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +2 while fighting a monster with a Battle effect.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "graceful"
  },
  {
    "id": "hero-graceful-l2",
    "type": "hero",
    "subtype": null,
    "title": "Graceful Glaive",
    "traits": [
      "Human",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +4 while fighting a monster with a Battle effect.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "graceful"
  },
  {
    "id": "hero-graceful-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Graceful Glaive",
    "traits": [
      "Human",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Immune to Battle and Aftermath effects.",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +5 while fighting a monster with a Battle of Aftermath effect.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "graceful"
  },
  {
    "id": "hero-grim-l1",
    "type": "hero",
    "subtype": null,
    "title": "Grim Blade",
    "traits": [
      "Human",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Set the defeated monster and this card aside. Return both to your deck at the end of the game.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "grim"
  },
  {
    "id": "hero-grim-l2",
    "type": "hero",
    "subtype": null,
    "title": "Grim Militant",
    "traits": [
      "Human",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Discard 2 XP to set the defeated monster aside. Return it to your deck at the end of the game.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "grim"
  },
  {
    "id": "hero-grim-l3",
    "type": "hero",
    "subtype": null,
    "title": "Grim Scourge",
    "traits": [
      "Human",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 3,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Set the defeated monster aside. Return it to your deck at the end of the game.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "grim"
  },
  {
    "id": "hero-grim-l4",
    "type": "hero",
    "subtype": null,
    "title": "Grim Reaper",
    "traits": [
      "Human",
      "Cleric",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 17,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Set the defeated monster and any monsters present aside. Return them to your deck at the end of the game.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "grim"
  },
  {
    "id": "hero-harruli-l1",
    "type": "hero",
    "subtype": null,
    "title": "Harruli Initiate",
    "traits": [
      "Human",
      "Fighter",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Magic Attack +1 for each spell present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "harruli"
  },
  {
    "id": "hero-harruli-l2",
    "type": "hero",
    "subtype": null,
    "title": "Harruli Spellsword",
    "traits": [
      "Human",
      "Fighter",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Magic Attack +2 for each spell present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "harruli"
  },
  {
    "id": "hero-harruli-l3",
    "type": "hero",
    "subtype": null,
    "title": "Harruli Avatar",
    "traits": [
      "Human",
      "Fighter",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Reveal the top 3 cards of your deck. Place 1 revealed spell (if any) into your hand. Discard the rest.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "harruli"
  },
  {
    "id": "hero-harruli-l4",
    "type": "hero",
    "subtype": null,
    "title": "Harruli Magus",
    "traits": [
      "Human",
      "Fighter",
      "Wizard",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 16,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Reveal the top 4 cards of your deck. Place all revealed spells (if any) into your hand. Discard the rest.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "harruli"
  },
  {
    "id": "hero-honormain-l1",
    "type": "hero",
    "subtype": null,
    "title": "Honormain Gallant",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Discard 1 card or destroy 1 disease.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Discard 1 card or destroy 1 disease.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "honormain"
  },
  {
    "id": "hero-honormain-l2",
    "type": "hero",
    "subtype": null,
    "title": "Honormain Defender",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard 1 card to add Magic Attack +1.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to add Magic Attack +2.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "honormain"
  },
  {
    "id": "hero-honormain-l3",
    "type": "hero",
    "subtype": null,
    "title": "Honormain Paladin",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard 1 card to add Magic Attack +1.",
          "repeatable": true
        },
        {
          "text": "Destroy 1 disease to add Magic Attack +2.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "honormain"
  },
  {
    "id": "hero-intelligent-l1",
    "type": "hero",
    "subtype": null,
    "title": "Intelligent",
    "traits": [
      "Human",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "After a card is destroyed, add Physical Attack +2.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "intelligent"
  },
  {
    "id": "hero-intelligent-l2",
    "type": "hero",
    "subtype": null,
    "title": "Intelligent Jack",
    "traits": [
      "Human",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "After a card is destroyed, add Physical Attack +2.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "intelligent"
  },
  {
    "id": "hero-intelligent-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Intelligent Jack",
    "traits": [
      "Human",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "After a card is destroyed, add Physical Attack +4 and Light +2.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "intelligent"
  },
  {
    "id": "hero-isri-l1",
    "type": "hero",
    "subtype": null,
    "title": "Isri Thrower",
    "traits": [
      "Human",
      "Fighter",
      "Ranger",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 item or weapon to add Physical Attack +1.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "isri"
  },
  {
    "id": "hero-isri-l2",
    "type": "hero",
    "subtype": null,
    "title": "Isri Bladespinner",
    "traits": [
      "Human",
      "Fighter",
      "Ranger",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 weapon to add Physical Attack equal to the weapon's Weight.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 weapon.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "isri"
  },
  {
    "id": "hero-isri-l3",
    "type": "hero",
    "subtype": null,
    "title": "Isri Helmsplitter",
    "traits": [
      "Human",
      "Fighter",
      "Ranger",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 weapon present or 1 weapon from the village to add Physical Attack equal to the weapon's Weight.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "isri"
  },
  {
    "id": "hero-isri-l4",
    "type": "hero",
    "subtype": null,
    "title": "Isri Heartseeker",
    "traits": [
      "Human",
      "Fighter",
      "Ranger",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 17,
    "level": 4,
    "xp": 0,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack equal to the Weight of 1 weapon equipped to this hero, or destroy 1 weapon from the village to add Physical Attack equal to that weapon's Weight.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "isri"
  },
  {
    "id": "hero-learned-l1",
    "type": "hero",
    "subtype": null,
    "title": "Learned",
    "traits": [
      "Human",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 2,
    "cost": 8,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Discard 1 card to draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Discard 1 card to draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "learned"
  },
  {
    "id": "hero-learned-l2",
    "type": "hero",
    "subtype": null,
    "title": "Learned Nano",
    "traits": [
      "Human",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 2,
    "cost": 11,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard 3 cards to draw 2 cards.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "learned"
  },
  {
    "id": "hero-learned-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Learned Nano",
    "traits": [
      "Human",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 2,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 2 cards. Discard 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "learned"
  },
  {
    "id": "hero-lorigg-l1",
    "type": "hero",
    "subtype": null,
    "title": "Lorigg Thief",
    "traits": [
      "Human",
      "Thief",
      "Level 1"
    ],
    "goldValue": 2,
    "strength": 4,
    "light": 1,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "lorigg"
  },
  {
    "id": "hero-lorigg-l2",
    "type": "hero",
    "subtype": null,
    "title": "Lorigg Rogue",
    "traits": [
      "Human",
      "Thief",
      "Level 2"
    ],
    "goldValue": 3,
    "strength": 4,
    "light": 1,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Each other player discards 1 card (of his or her choice).",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "lorigg"
  },
  {
    "id": "hero-lorigg-l3",
    "type": "hero",
    "subtype": null,
    "title": "Lorigg Outlaw",
    "traits": [
      "Human",
      "Thief",
      "Level 3"
    ],
    "goldValue": 4,
    "strength": 5,
    "light": 2,
    "cost": 10,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Each other player discards 1 card (of his or her choice).",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "lorigg"
  },
  {
    "id": "hero-lorigg-l4",
    "type": "hero",
    "subtype": null,
    "title": "Lorigg Guildmaster",
    "traits": [
      "Human",
      "Thief",
      "Level 4"
    ],
    "goldValue": 5,
    "strength": 5,
    "light": 3,
    "cost": 14,
    "level": 4,
    "xp": 0,
    "points": 3,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Each other player reveals his or her hand and discards his or her highest level hero.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Each other player reveals his or her hand and discards his or her highest level hero.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "lorigg"
  },
  {
    "id": "hero-moonclaw-l1",
    "type": "hero",
    "subtype": null,
    "title": "Moonclaw Scout",
    "traits": [
      "Corvaxis",
      "Ranger",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "If you did not defeat a monster, destroy this card.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "moonclaw"
  },
  {
    "id": "hero-moonclaw-l2",
    "type": "hero",
    "subtype": null,
    "title": "Moonclaw Courser",
    "traits": [
      "Corvaxis",
      "Ranger",
      "Level 2"
    ],
    "goldValue": -1,
    "strength": 5,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Reveal the bottom card of the dungeon deck. If it is a non-Guardian monster, you may switch it with a monster in rank 3 or higher.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "moonclaw"
  },
  {
    "id": "hero-moonclaw-l3",
    "type": "hero",
    "subtype": null,
    "title": "Moonclaw Ranger",
    "traits": [
      "Corvaxis",
      "Ranger",
      "Level 3"
    ],
    "goldValue": -2,
    "strength": 5,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Reveal the bottom card of the dungeon deck. If it is a non-Guardian monster, you may switch it with any monster in the hall.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "moonclaw"
  },
  {
    "id": "hero-mystic-l1",
    "type": "hero",
    "subtype": null,
    "title": "Mystic",
    "traits": [
      "Human",
      "Fighter",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        },
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "mystic"
  },
  {
    "id": "hero-mystic-l2",
    "type": "hero",
    "subtype": null,
    "title": "Mystic Glaive",
    "traits": [
      "Human",
      "Fighter",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "light": 1,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Convert this hero's Physical Attack to Magic Attack.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "mystic"
  },
  {
    "id": "hero-mystic-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Mystic Glaive",
    "traits": [
      "Human",
      "Fighter",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 6,
    "light": 1,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +6",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Convert this hero's Physical Attack to Magic Attack.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "mystic"
  },
  {
    "id": "hero-outlands-l1",
    "type": "hero",
    "subtype": null,
    "title": "Outlands Warrior",
    "traits": [
      "Human",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 8,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 food to add Physical Attack +3.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "outlands"
  },
  {
    "id": "hero-outlands-l2",
    "type": "hero",
    "subtype": null,
    "title": "Outlands Slayer",
    "traits": [
      "Human",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 11,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 for each monster present.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 food to add Physical Attack +3.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "outlands"
  },
  {
    "id": "hero-outlands-l3",
    "type": "hero",
    "subtype": null,
    "title": "Outlands Khan",
    "traits": [
      "Human",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +2 for each monster present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "outlands"
  },
  {
    "id": "hero-outlands-l4",
    "type": "hero",
    "subtype": null,
    "title": "Outlands Sovereign",
    "traits": [
      "Human",
      "Fighter",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 10,
    "cost": 17,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +7",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack equal to the total XP of all monsters present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "outlands"
  },
  {
    "id": "hero-patternmage-l1",
    "type": "hero",
    "subtype": null,
    "title": "Patternmage Augur",
    "traits": [
      "Human",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 2,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Look at the top 2 cards of your deck. Discard 1 of them. Place the other on top of your deck.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Look at the top 2 cards of your deck. Discard 1 of them. Place the other on top of your deck.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "patternmage"
  },
  {
    "id": "hero-patternmage-l2",
    "type": "hero",
    "subtype": null,
    "title": "Patternmage Diviner",
    "traits": [
      "Human",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Look at the top 3 cards of your deck. Discard 2 of them. Place the other on top of your deck.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Look at the top 3 cards of your deck. Discard 2 of them. Place the other on top of your deck.",
          "repeatable": false
        },
        {
          "text": "Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "patternmage"
  },
  {
    "id": "hero-patternmage-l3",
    "type": "hero",
    "subtype": null,
    "title": "Patternmage Ordainer",
    "traits": [
      "Human",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Look at the top 3 cards of your deck. Discard any or all of them. Place the rest on top of your deck in any order.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Look at the top 3 cards of your deck. Discard any or all of them. Place the rest on top of your deck in any order.",
          "repeatable": false
        },
        {
          "text": "Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "patternmage"
  },
  {
    "id": "hero-profaned-l1",
    "type": "hero",
    "subtype": null,
    "title": "Profaned Acolyte",
    "traits": [
      "Human",
      "Wizard",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Light +1. Gain 1 curse.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "profaned"
  },
  {
    "id": "hero-profaned-l2",
    "type": "hero",
    "subtype": null,
    "title": "Profaned Curate",
    "traits": [
      "Human",
      "Wizard",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 4,
    "light": 1,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Draw 1 card. Gain 1 curse.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Draw 1 card. Gain 1 curse.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to add Magic Attack +3.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "profaned"
  },
  {
    "id": "hero-profaned-l3",
    "type": "hero",
    "subtype": null,
    "title": "Profaned Patriarch",
    "traits": [
      "Human",
      "Wizard",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "light": 1,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 disease to add Magic Attack +3 and draw 1 card.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "profaned"
  },
  {
    "id": "hero-rapparee-l1",
    "type": "hero",
    "subtype": null,
    "title": "Rapparee Scrounger",
    "traits": [
      "Elf",
      "Thief",
      "Level 1"
    ],
    "goldValue": 3,
    "strength": 3,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "rapparee"
  },
  {
    "id": "hero-rapparee-l2",
    "type": "hero",
    "subtype": null,
    "title": "Rapparee Skimmer",
    "traits": [
      "Elf",
      "Thief",
      "Level 2"
    ],
    "goldValue": 3,
    "strength": 4,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 item or weapon.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "rapparee"
  },
  {
    "id": "hero-rapparee-l3",
    "type": "hero",
    "subtype": null,
    "title": "Rapparee Looter",
    "traits": [
      "Elf",
      "Thief",
      "Level 3"
    ],
    "goldValue": 4,
    "strength": 4,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 village card. Place it on top of your deck.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "rapparee"
  },
  {
    "id": "hero-regian-l1",
    "type": "hero",
    "subtype": null,
    "title": "Regian Cleric",
    "traits": [
      "Human",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "regian"
  },
  {
    "id": "hero-regian-l2",
    "type": "hero",
    "subtype": null,
    "title": "Regian Priest",
    "traits": [
      "Human",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "regian"
  },
  {
    "id": "hero-regian-l3",
    "type": "hero",
    "subtype": null,
    "title": "Regian Bishop",
    "traits": [
      "Human",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 2 cards.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to draw 2 cards.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "regian"
  },
  {
    "id": "hero-regian-l4",
    "type": "hero",
    "subtype": null,
    "title": "Regian Archbishop",
    "traits": [
      "Human",
      "Cleric",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 15,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 3 cards.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to draw 3 cards.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "regian"
  },
  {
    "id": "hero-rugged-l1",
    "type": "hero",
    "subtype": null,
    "title": "Rugged",
    "traits": [
      "Human",
      "Ranger",
      "Level 1"
    ],
    "goldValue": -1,
    "strength": 5,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Mark 1 monster in the hall.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Mark 1 monster in the hall.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "After another player selects a monster with your mark to fight, gain 1 XP.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "rugged"
  },
  {
    "id": "hero-rugged-l2",
    "type": "hero",
    "subtype": null,
    "title": "Rugged Jack",
    "traits": [
      "Human",
      "Ranger",
      "Level 2"
    ],
    "goldValue": -1,
    "strength": 6,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Mark 1 monster in the hall.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "After any player (including you) selects a monster with your mark to fight, gain 1 XP.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "rugged"
  },
  {
    "id": "hero-rugged-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Rugged Jack",
    "traits": [
      "Human",
      "Ranger",
      "Level 3"
    ],
    "goldValue": -1,
    "strength": 6,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Mark 1 monster in the hall.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "After another player selects a monster with your mark to fight, take a prepare action.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "rugged"
  },
  {
    "id": "hero-silvertongue-l1",
    "type": "hero",
    "subtype": null,
    "title": "Silvertongue Swindler",
    "traits": [
      "Human",
      "Thief",
      "Level 1"
    ],
    "goldValue": 1,
    "strength": 4,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Place a village card present back on its stack to gain 2 gold.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "silvertongue"
  },
  {
    "id": "hero-silvertongue-l2",
    "type": "hero",
    "subtype": null,
    "title": "Silvertongue Rook",
    "traits": [
      "Human",
      "Thief",
      "Level 2"
    ],
    "goldValue": 2,
    "strength": 4,
    "cost": 7,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Give another player a village card present to either add Physical Attack +2 or gain 2 gold.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Give another player a village card present to either add Physical Attack +2 or gain 2 gold.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "silvertongue"
  },
  {
    "id": "hero-silvertongue-l3",
    "type": "hero",
    "subtype": null,
    "title": "Silvertongue Sharp",
    "traits": [
      "Human",
      "Thief",
      "Level 3"
    ],
    "goldValue": 3,
    "strength": 5,
    "cost": 10,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Give another player a village card present to add Physical Attack +3 and draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Give another player a village card present to add Physical Attack +3 and draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "silvertongue"
  },
  {
    "id": "hero-skinshifter-l1",
    "type": "hero",
    "subtype": null,
    "title": "Skinshifter Clawhand",
    "traits": [
      "Dwarf",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard a card to add Physical Attack +2 and Strength +1.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "skinshifter"
  },
  {
    "id": "hero-skinshifter-l2",
    "type": "hero",
    "subtype": null,
    "title": "Skinshifter Mauler",
    "traits": [
      "Dwarf",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard a card to add Physical Attack +3 and Strength +2.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "skinshifter"
  },
  {
    "id": "hero-skinshifter-l3",
    "type": "hero",
    "subtype": null,
    "title": "Skinshifter Terror",
    "traits": [
      "Dwarf",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard or destroy a card to add Physical Attack +4 and Strength +3. If the card was a disease, you may use this ability a second time this turn.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "skinshifter"
  },
  {
    "id": "hero-spellsword-l1",
    "type": "hero",
    "subtype": null,
    "title": "Spellsword Venturer",
    "traits": [
      "Elf",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 8,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +1 if at least 1 magic item, magic weapon, or spell is present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "spellsword"
  },
  {
    "id": "hero-spellsword-l2",
    "type": "hero",
    "subtype": null,
    "title": "Spellsword Challenger",
    "traits": [
      "Elf",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "light": 1,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +1 for each magic item, magic weapon, and spell present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "spellsword"
  },
  {
    "id": "hero-spellsword-l3",
    "type": "hero",
    "subtype": null,
    "title": "Spellsword Vanquisher",
    "traits": [
      "Elf",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 6,
    "light": 1,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +2 for each magic item, magic weapon, and spell present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 magic item, magic weapon, or spell.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "spellsword"
  },
  {
    "id": "hero-stealthy-l1",
    "type": "hero",
    "subtype": null,
    "title": "Stealthy",
    "traits": [
      "Human",
      "Thief",
      "Level 1"
    ],
    "goldValue": 2,
    "strength": 3,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Buy 1 additional card this turn.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "stealthy"
  },
  {
    "id": "hero-stealthy-l2",
    "type": "hero",
    "subtype": null,
    "title": "Stealthy Jack",
    "traits": [
      "Human",
      "Thief",
      "Level 2"
    ],
    "goldValue": 2,
    "strength": 4,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Buy 1 additional card this turn.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 non-hero card.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "stealthy"
  },
  {
    "id": "hero-stealthy-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Stealthy Jack",
    "traits": [
      "Human",
      "Thief",
      "Level 3"
    ],
    "goldValue": 2,
    "strength": 4,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Buy 1 card and add it to your hand.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Buy 1 card and add it to your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "stealthy"
  },
  {
    "id": "hero-sternnkin-l1",
    "type": "hero",
    "subtype": null,
    "title": "Sternnkin Orcbane",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "sternnkin"
  },
  {
    "id": "hero-sternnkin-l2",
    "type": "hero",
    "subtype": null,
    "title": "Sternnkin Ettinbane",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +2 when fighting monsters with VP greater than this card's Strength.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "sternnkin"
  },
  {
    "id": "hero-sternnkin-l3",
    "type": "hero",
    "subtype": null,
    "title": "Sternnkin Dragonbane",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +3 when fighting monsters with VP greater than this card's Strength.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "sternnkin"
  },
  {
    "id": "hero-stoneguard-l1",
    "type": "hero",
    "subtype": null,
    "title": "Stoneguard Brute",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 8,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +1 while equipped.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "stoneguard"
  },
  {
    "id": "hero-stoneguard-l2",
    "type": "hero",
    "subtype": null,
    "title": "Stoneguard Bruiser",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 11,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +2 while equipped.",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +1 for each mercenary present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "stoneguard"
  },
  {
    "id": "hero-stoneguard-l3",
    "type": "hero",
    "subtype": null,
    "title": "Stoneguard Tanker",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +3 while equipped.",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +1 for each mercenary present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Add any mercenaries present to your new hand at the end of the turn.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "stoneguard"
  },
  {
    "id": "hero-stoneguard-l4",
    "type": "hero",
    "subtype": null,
    "title": "Stoneguard Juggernaut",
    "traits": [
      "Dwarf",
      "Fighter",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 9,
    "cost": 17,
    "level": 4,
    "xp": 0,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +5 while equipped.",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +2 for each mercenary present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Add any mercenaries present to your new hand at the end of the turn.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "stoneguard"
  },
  {
    "id": "hero-strong-l1",
    "type": "hero",
    "subtype": null,
    "title": "Strong",
    "traits": [
      "Human",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 8,
    "level": 1,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "You cannot level up a Regular into this card.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Discard 4 XP to level up this hero.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "strong"
  },
  {
    "id": "hero-strong-l2",
    "type": "hero",
    "subtype": null,
    "title": "Strong Glaive",
    "traits": [
      "Human",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 11,
    "level": 2,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +6",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Discard 6 XP to level up this hero.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "strong"
  },
  {
    "id": "hero-strong-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Strong Glaive",
    "traits": [
      "Human",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 8,
    "cost": 14,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +9",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "strong"
  },
  {
    "id": "hero-strongwilled-l1",
    "type": "hero",
    "subtype": null,
    "title": "Strong-willed",
    "traits": [
      "Human",
      "Thief",
      "Level 1"
    ],
    "goldValue": 2,
    "strength": 4,
    "light": 1,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "strongwilled"
  },
  {
    "id": "hero-strongwilled-l2",
    "type": "hero",
    "subtype": null,
    "title": "Strong-willed Jack",
    "traits": [
      "Human",
      "Thief",
      "Level 2"
    ],
    "goldValue": 2,
    "strength": 4,
    "light": 1,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Use the Dungeon ability on one item card even if you have already used it this turn.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "strongwilled"
  },
  {
    "id": "hero-strongwilled-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Strong-willed Jack",
    "traits": [
      "Human",
      "Thief",
      "Level 3"
    ],
    "goldValue": 2,
    "strength": 4,
    "light": 2,
    "cost": 10,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Each other player discards 1 item or shows a hand with none. Add Physical Attack equal to the cost of 1 discarded card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "strongwilled"
  },
  {
    "id": "hero-swift-l1",
    "type": "hero",
    "subtype": null,
    "title": "Swift",
    "traits": [
      "Human",
      "Ranger",
      "Level 1"
    ],
    "goldValue": -1,
    "strength": 5,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Mark 1 non-guardian monster in the hall.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "After another player selects a monster with your mark to fight, add Health +1 to that monster.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "swift"
  },
  {
    "id": "hero-swift-l2",
    "type": "hero",
    "subtype": null,
    "title": "Swift Jack",
    "traits": [
      "Human",
      "Ranger",
      "Level 2"
    ],
    "goldValue": -1,
    "strength": 6,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Mark 1 non-guardian monster in the hall.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "After another player selects a monster with your mark to fight, add Health +2 to that monster.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "swift"
  },
  {
    "id": "hero-swift-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Swift Jack",
    "traits": [
      "Human",
      "Ranger",
      "Level 3"
    ],
    "goldValue": -1,
    "strength": 6,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +6",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Mark 1 non-guardian monster in the hall.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "After another player selects a monster with your mark to fight, add Health +3 to that monster.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "swift"
  },
  {
    "id": "hero-thornwood-l1",
    "type": "hero",
    "subtype": null,
    "title": "Thornwood Stalker",
    "traits": [
      "Human",
      "Ranger",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +1 for each rank of the monster you are fighting.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "thornwood"
  },
  {
    "id": "hero-thornwood-l2",
    "type": "hero",
    "subtype": null,
    "title": "Thornwood Hunter",
    "traits": [
      "Human",
      "Ranger",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +1 for each rank of the monster you are fighting.",
          "repeatable": false
        },
        {
          "text": "Add Light +1 against the highest rank.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "thornwood"
  },
  {
    "id": "hero-thornwood-l3",
    "type": "hero",
    "subtype": null,
    "title": "Thornwood Ranger",
    "traits": [
      "Human",
      "Ranger",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +2 for each rank of the monster you are fighting.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Gain 1 XP if you defeated the monster in the highest rank.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "thornwood"
  },
  {
    "id": "hero-thornwood-l4",
    "type": "hero",
    "subtype": null,
    "title": "Thornwood Exterminator",
    "traits": [
      "Human",
      "Ranger",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 16,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +3 for each rank of the monster you are fighting.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Discard 5 XP to take another turn.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "thornwood"
  },
  {
    "id": "hero-tholis-l1",
    "type": "hero",
    "subtype": null,
    "title": "Tholis Medium",
    "traits": [
      "Human",
      "Thief",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 1,
    "strength": 3,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Look at the top 3 cards of the dungeon deck. Return them in any order.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tholis"
  },
  {
    "id": "hero-tholis-l2",
    "type": "hero",
    "subtype": null,
    "title": "Tholis Clairvoyant",
    "traits": [
      "Human",
      "Thief",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 1,
    "strength": 4,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Look at the top 3 cards of the dungeon deck. You may switch 1 of them with the monster in rank 1. Return the cards to the top of the dungeon deck in any order.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tholis"
  },
  {
    "id": "hero-tholis-l3",
    "type": "hero",
    "subtype": null,
    "title": "Tholis Oracle",
    "traits": [
      "Human",
      "Thief",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 1,
    "strength": 4,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Each other player reveals the top 5 cards of his or her deck, discards any heroes, then returns the rest in any order.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tholis"
  },
  {
    "id": "hero-tholis-l4",
    "type": "hero",
    "subtype": null,
    "title": "Tholis Visionary",
    "traits": [
      "Human",
      "Thief",
      "Wizard",
      "Level 4"
    ],
    "goldValue": 2,
    "strength": 4,
    "cost": 17,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Each other player reveals the top 5 cards of his or her deck, discards any cards with a gold cost, then returns the rest in any order.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tholis"
  },
  {
    "id": "hero-thundermage-l1",
    "type": "hero",
    "subtype": null,
    "title": "Thundermage Summoner",
    "traits": [
      "Human",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 3,
    "light": 1,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "thundermage"
  },
  {
    "id": "hero-thundermage-l2",
    "type": "hero",
    "subtype": null,
    "title": "Thundermage Evoker",
    "traits": [
      "Human",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 3,
    "light": 2,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "thundermage"
  },
  {
    "id": "hero-thundermage-l3",
    "type": "hero",
    "subtype": null,
    "title": "Thundermage Bolter",
    "traits": [
      "Human",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 4,
    "light": 2,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Place the monster from rank 1 into your discard pile (you do not collect XP). End your turn.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "thundermage"
  },
  {
    "id": "hero-tough-l1",
    "type": "hero",
    "subtype": null,
    "title": "Tough",
    "traits": [
      "Human",
      "Fighter",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "If equipped, draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 weapon.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "tough"
  },
  {
    "id": "hero-tough-l2",
    "type": "hero",
    "subtype": null,
    "title": "Tough Glaive",
    "traits": [
      "Human",
      "Fighter",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "If equipped, draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Place the top card of the Tough stack into your discard pile.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "tough"
  },
  {
    "id": "hero-tough-l3",
    "type": "hero",
    "subtype": null,
    "title": "Enhanced Tough Glaive",
    "traits": [
      "Human",
      "Fighter",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +6",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "If equipped, draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Place the top card of any hero stack into your discard pile.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "tough"
  },
  {
    "id": "hero-tower-l1",
    "type": "hero",
    "subtype": null,
    "title": "Tower Apprentice",
    "traits": [
      "Dwarf",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 2,
    "light": 1,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tower"
  },
  {
    "id": "hero-tower-l2",
    "type": "hero",
    "subtype": null,
    "title": "Tower Adept",
    "traits": [
      "Dwarf",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 3,
    "light": 1,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tower"
  },
  {
    "id": "hero-tower-l3",
    "type": "hero",
    "subtype": null,
    "title": "Tower Master",
    "traits": [
      "Dwarf",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 3,
    "light": 2,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 2 cards.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tower"
  },
  {
    "id": "hero-tuath-l1",
    "type": "hero",
    "subtype": null,
    "title": "Tuath Tracker",
    "traits": [
      "Human",
      "Ranger",
      "Level 1"
    ],
    "goldValue": -1,
    "strength": 4,
    "cost": 4,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tuath"
  },
  {
    "id": "hero-tuath-l2",
    "type": "hero",
    "subtype": null,
    "title": "Tuath Trapper",
    "traits": [
      "Human",
      "Ranger",
      "Level 2"
    ],
    "goldValue": -1,
    "strength": 5,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Place a monster from the hall on the bottom of the dungeon deck. Refill the hall.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tuath"
  },
  {
    "id": "hero-tuath-l3",
    "type": "hero",
    "subtype": null,
    "title": "Tuath Banisher",
    "traits": [
      "Human",
      "Ranger",
      "Level 3"
    ],
    "goldValue": -2,
    "strength": 6,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Place a monster from the hall on the bottom of the dungeon deck. Refill the hall. Ignore Darkness penalties.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "tuath"
  },
  {
    "id": "hero-veilminder-l1",
    "type": "hero",
    "subtype": null,
    "title": "Veilminder Martyr",
    "traits": [
      "Elf",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy this card to cancel one Battle or Aftermath effect on a monster in the hall.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "veilminder"
  },
  {
    "id": "hero-veilminder-l2",
    "type": "hero",
    "subtype": null,
    "title": "Veilminder Renunciate",
    "traits": [
      "Elf",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 7,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard this card to cancel one Battle or Aftermath effect on a monster in the hall.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "veilminder"
  },
  {
    "id": "hero-veilminder-l3",
    "type": "hero",
    "subtype": null,
    "title": "Veilminder Priest",
    "traits": [
      "Elf",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard this card to cancel all Battle and Aftermath effects. Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "veilminder"
  },
  {
    "id": "hero-verdan-l1",
    "type": "hero",
    "subtype": null,
    "title": "Verdan Minstrel",
    "traits": [
      "Elf",
      "Ranger",
      "Thief",
      "Level 1"
    ],
    "goldValue": 1,
    "strength": 5,
    "light": 1,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Each other player with 6 or more cards discards 1 random card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "verdan"
  },
  {
    "id": "hero-verdan-l2",
    "type": "hero",
    "subtype": null,
    "title": "Verdan Bard",
    "traits": [
      "Elf",
      "Ranger",
      "Thief",
      "Level 2"
    ],
    "goldValue": 2,
    "strength": 5,
    "light": 1,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard 2 XP to place the rank 1 monster on the bottom of the dungeon deck. Refill the hall.",
          "repeatable": false
        },
        {
          "text": "Each other player reveals 1 spell or discards 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "verdan"
  },
  {
    "id": "hero-verdan-l3",
    "type": "hero",
    "subtype": null,
    "title": "Verdan Troubadour",
    "traits": [
      "Elf",
      "Ranger",
      "Thief",
      "Level 3"
    ],
    "goldValue": 2,
    "strength": 5,
    "light": 1,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 1,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard 1 XP to place a monster from the hall on the bottom of the dungeon deck. Refill the hall.",
          "repeatable": false
        },
        {
          "text": "Each other player discards 1 XP.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "verdan"
  },
  {
    "id": "hero-verdan-l4",
    "type": "hero",
    "subtype": null,
    "title": "Verdan Rhapsodist",
    "traits": [
      "Elf",
      "Ranger",
      "Thief",
      "Level 4"
    ],
    "goldValue": 2,
    "strength": 5,
    "light": 1,
    "cost": 16,
    "level": 4,
    "xp": 0,
    "points": 3,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Place a monster from the hall on the bottom of the dungeon deck. Refill the hall.",
          "repeatable": false
        },
        {
          "text": "Each other player discards 1 XP and 1 random card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "verdan"
  },
  {
    "id": "hero-veris-l1",
    "type": "hero",
    "subtype": null,
    "title": "Veris Squire",
    "traits": [
      "Elf",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Light +1 to each equipped weapon.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "veris"
  },
  {
    "id": "hero-veris-l2",
    "type": "hero",
    "subtype": null,
    "title": "Veris Enhancer",
    "traits": [
      "Elf",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +1 and Light +1 to each equipped weapon.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "veris"
  },
  {
    "id": "hero-veris-l3",
    "type": "hero",
    "subtype": null,
    "title": "Veris Enchanter",
    "traits": [
      "Elf",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +2 and Light +2 to each equipped weapon.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack equal to the total Light present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "veris"
  },
  {
    "id": "hero-veris-l4",
    "type": "hero",
    "subtype": null,
    "title": "Veris Artisan",
    "traits": [
      "Elf",
      "Wizard",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 16,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +3 and Light +3 to each equipped weapon.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Magic Attack equal to the total Light present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "veris"
  },
  {
    "id": "hero-whetmage-l1",
    "type": "hero",
    "subtype": null,
    "title": "Whetmage Honer",
    "traits": [
      "Human",
      "Wizard",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 2,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Level up a Regular or another level 1 hero. Add the newly leveled hero to your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "whetmage"
  },
  {
    "id": "hero-whetmage-l2",
    "type": "hero",
    "subtype": null,
    "title": "Whetmage Finisher",
    "traits": [
      "Human",
      "Wizard",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 2,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Level up another hero. Add the newly leveled hero to your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "whetmage"
  },
  {
    "id": "hero-whetmage-l3",
    "type": "hero",
    "subtype": null,
    "title": "Whetmage Polisher",
    "traits": [
      "Human",
      "Wizard",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 3,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Level up any number of heroes. Add the newly leveled up heroes to your hand. You cannot level a hero that has already been leveled up this turn.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "whetmage"
  },
  {
    "id": "hero-wildwood-l1",
    "type": "hero",
    "subtype": null,
    "title": "Wildwood Assailant",
    "traits": [
      "Elf",
      "Ranger",
      "Level 1"
    ],
    "goldValue": -1,
    "strength": 5,
    "cost": 4,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "wildwood"
  },
  {
    "id": "hero-wildwood-l2",
    "type": "hero",
    "subtype": null,
    "title": "Wildwood Strategist",
    "traits": [
      "Elf",
      "Ranger",
      "Level 2"
    ],
    "goldValue": -1,
    "strength": 5,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Physical Attack +1 for each monster revealed in your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "wildwood"
  },
  {
    "id": "hero-wildwood-l3",
    "type": "hero",
    "subtype": null,
    "title": "Wildwood Chieftain",
    "traits": [
      "Elf",
      "Ranger",
      "Level 3"
    ],
    "goldValue": -2,
    "strength": 6,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Physical Attack +1 for each monster revealed in your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Place 1 non-Guardian monster from the hall on the bottom of the dungeon deck. Refill the hall.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "wildwood"
  },
  {
    "id": "hero-woodfolk-l1",
    "type": "hero",
    "subtype": null,
    "title": "Woodfolk Herbalist",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 5,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +3 against monsters that give diseases.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "woodfolk"
  },
  {
    "id": "hero-woodfolk-l2",
    "type": "hero",
    "subtype": null,
    "title": "Woodfolk Shaman",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 8,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +4 against monsters that give diseases.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "woodfolk"
  },
  {
    "id": "hero-woodfolk-l3",
    "type": "hero",
    "subtype": null,
    "title": "Woodfolk Druid",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 11,
    "level": 3,
    "xp": 0,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 disease to add Magic Attack +4 and draw 1 card.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "woodfolk"
  },
  {
    "id": "hero-woodfolk-l4",
    "type": "hero",
    "subtype": null,
    "title": "Woodfolk Hierophant",
    "traits": [
      "Human",
      "Fighter",
      "Cleric",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 7,
    "cost": 15,
    "level": 4,
    "xp": 0,
    "points": 5,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 disease to add Magic Attack +6 and draw 1 card.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "woodfolk"
  },
  {
    "id": "hero-woodguard-l1",
    "type": "hero",
    "subtype": null,
    "title": "Woodguard Scion",
    "traits": [
      "Treefolk",
      "Cleric",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 10,
    "light": 1,
    "cost": 7,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        },
        {
          "text": "Cannot equip a weapon.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +2. Each other player draws 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "woodguard"
  },
  {
    "id": "hero-woodguard-l2",
    "type": "hero",
    "subtype": null,
    "title": "Woodguard Sapling",
    "traits": [
      "Treefolk",
      "Cleric",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 10,
    "light": 1,
    "cost": 10,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Cannot equip a weapon.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +4. Each other player draws 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "woodguard"
  },
  {
    "id": "hero-woodguard-l3",
    "type": "hero",
    "subtype": null,
    "title": "Woodguard Elder",
    "traits": [
      "Treefolk",
      "Cleric",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 10,
    "light": 1,
    "cost": 13,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Cannot equip a weapon.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +6. Each player draws 1 card.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "woodguard"
  },
  {
    "id": "hero-xenomorph-l1",
    "type": "hero",
    "subtype": null,
    "title": "Xenomorph Changeling",
    "traits": [
      "Xenomorph",
      "(Unclassed)",
      "Level 1"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 6,
    "level": 1,
    "xp": 2,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "This card becomes a duplicate of an equal or lower level non-Xenomorph hero present or in your discard pile.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "This card becomes a duplicate of an equal or lower level non-Xenomorph hero present or in your discard pile.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "xenomorph"
  },
  {
    "id": "hero-xenomorph-l2",
    "type": "hero",
    "subtype": null,
    "title": "Xenomorph Shadow",
    "traits": [
      "Xenomorph",
      "(Unclassed)",
      "Level 2"
    ],
    "goldValue": 0,
    "strength": 4,
    "cost": 9,
    "level": 2,
    "xp": 3,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "This card becomes a duplicate of an equal or lower level non-Xenomorph hero present, or in your discard pile, or on top of a hero stack.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "This card becomes a duplicate of an equal or lower level non-Xenomorph hero present, or in your discard pile, or on top of a hero stack.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "xenomorph"
  },
  {
    "id": "hero-xenomorph-l3",
    "type": "hero",
    "subtype": null,
    "title": "Xenomorph Shifter",
    "traits": [
      "Xenomorph",
      "(Unclassed)",
      "Level 3"
    ],
    "goldValue": 0,
    "strength": 5,
    "cost": 12,
    "level": 3,
    "xp": 0,
    "points": 2,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy the top card of a hero stack.",
          "repeatable": false
        },
        {
          "text": "This card becomes a duplicate of an equal or lower level non-Xenomorph hero present, or in your discard pile, or on top of a hero stack.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy the top card of a hero stack.",
          "repeatable": false
        },
        {
          "text": "This card becomes a duplicate of an equal or lower level non-Xenomorph hero present, or in your discard pile, or on top of a hero stack.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "xenomorph"
  },
  {
    "id": "hero-xenomorph-l4",
    "type": "hero",
    "subtype": null,
    "title": "Xenomorph Unbound",
    "traits": [
      "Xenomorph",
      "(Unclassed)",
      "Level 4"
    ],
    "goldValue": 0,
    "strength": 6,
    "cost": 16,
    "level": 4,
    "xp": 0,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "This card becomes a duplicate of an equal or lower level non-Xenomorph hero present, or in your discard pile, or in a hero stack (even if not on top).",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "This card becomes a duplicate of an equal or lower level non-Xenomorph hero present, or in your discard pile, or in a hero stack (even if not on top).",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "xenomorph"
  },
  {
    "id": "monster-murden",
    "type": "monster",
    "subtype": null,
    "title": "Murden",
    "traits": [
      "Abhuman",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 3,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Suffer Light -1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "If there is Darkness in this rank, add Physical Attack +2 to each thief.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abhuman"
  },
  {
    "id": "monster-chirog",
    "type": "monster",
    "subtype": null,
    "title": "Chirog",
    "traits": [
      "Abhuman",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Add Magic Attack +1 to each wizard.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abhuman"
  },
  {
    "id": "monster-margr",
    "type": "monster",
    "subtype": null,
    "title": "Margr",
    "traits": [
      "Abhuman",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 1 disease",
          "repeatable": false
        }
      ],
      "trophy": [
        {
          "text": "Add Physical Attack +1 to each cleric.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abhuman"
  },
  {
    "id": "monster-sathosh",
    "type": "monster",
    "subtype": null,
    "title": "Sathosh",
    "traits": [
      "Abhuman",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 4,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "After you select this monster to fight, move it to rank 3.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Add Physical Attack +1 to each ranger.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abhuman"
  },
  {
    "id": "monster-culova",
    "type": "monster",
    "subtype": null,
    "title": "Culova",
    "traits": [
      "Abhuman",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Add Physical Attack +1 to each fighter.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abhuman"
  },
  {
    "id": "monster-archduke-of-pain",
    "type": "monster",
    "subtype": null,
    "title": "Archduke of Pain",
    "traits": [
      "Abyssal",
      "Elite",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 10,
    "level": 2,
    "xp": 3,
    "points": 8,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack required.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy each cleric and wizard.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Destroy the top 2 cards of each hero stack.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "abyssalElite"
  },
  {
    "id": "monster-grudgebeast",
    "type": "monster",
    "subtype": null,
    "title": "Grudgebeast",
    "traits": [
      "Abyssal",
      "Elite",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 2,
    "xp": 1,
    "points": 2,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalElite"
  },
  {
    "id": "monster-tormentor",
    "type": "monster",
    "subtype": null,
    "title": "Tormentor",
    "traits": [
      "Abyssal",
      "Elite",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 3,
    "points": 6,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Halve Total Attack Value (round down) unless a weapon is equipped.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 cleric.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalElite"
  },
  {
    "id": "monster-succubus",
    "type": "monster",
    "subtype": null,
    "title": "Succubus",
    "traits": [
      "Abyssal",
      "Elite",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Halve Total Attack Value (round down) unless Magic Attack is present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalElite"
  },
  {
    "id": "monster-the-unchained",
    "type": "monster",
    "subtype": null,
    "title": "The Unchained",
    "traits": [
      "Abyssal",
      "Elite",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 2,
    "xp": 1,
    "points": 3,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [
        {
          "text": "Magic Attack +1.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalElite"
  },
  {
    "id": "monster-doomspawn",
    "type": "monster",
    "subtype": null,
    "title": "Doomspawn",
    "traits": [
      "Abyssal",
      "Horde",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 4,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Add Health +1 for each other Doomspawn in the hall.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 1 disease for each Abyssal, Doomknight, and Undead monster present (in your hand).",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalHorde"
  },
  {
    "id": "monster-death-polyps",
    "type": "monster",
    "subtype": null,
    "title": "Death Polyps",
    "traits": [
      "Abyssal",
      "Malformed",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 10,
    "level": 2,
    "xp": 7,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 monster. Gain 1 disease for each XP that monster was worth.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalMalformed"
  },
  {
    "id": "monster-ghost-toxin",
    "type": "monster",
    "subtype": null,
    "title": "Ghost Toxin",
    "traits": [
      "Abyssal",
      "Malformed",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 Light item. Gain 1 disease if a Light item is destroyed.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalMalformed"
  },
  {
    "id": "monster-snakewyrm",
    "type": "monster",
    "subtype": null,
    "title": "Snakewyrm",
    "traits": [
      "Abyssal",
      "Malformed",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 2,
    "points": 5,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 2 Regulars. Gain 1 disease for each Regular destroyed.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalMalformed"
  },
  {
    "id": "monster-spike-lasher",
    "type": "monster",
    "subtype": null,
    "title": "Spike Lasher",
    "traits": [
      "Abyssal",
      "Malformed",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 1,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy all food. Gain 1 disease for each food destroyed.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalMalformed"
  },
  {
    "id": "monster-spider-bloat",
    "type": "monster",
    "subtype": null,
    "title": "Spider Bloat",
    "traits": [
      "Abyssal",
      "Malformed",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 9,
    "level": 2,
    "xp": 3,
    "points": 6,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 fighter. Gain 1 disease for each level of that fighter.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalMalformed"
  },
  {
    "id": "monster-razorback",
    "type": "monster",
    "subtype": null,
    "title": "Razorback",
    "traits": [
      "Abyssal",
      "Thunderspawn",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy all rangers.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "All players reveal the top 5 cards from their decks. Destroy all revealed rangers. Discard the rest.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "abyssalThunderspawn"
  },
  {
    "id": "monster-the-bloodless",
    "type": "monster",
    "subtype": null,
    "title": "The Bloodless",
    "traits": [
      "Abyssal",
      "Thunderspawn",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 1,
    "xp": 2,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy the hero with the highest Attack Value (including weapon bonuses).",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "All players reveal the top 5 cards from their decks. Destroy all revealed wizards. Discard the rest.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "abyssalThunderspawn"
  },
  {
    "id": "monster-regicide",
    "type": "monster",
    "subtype": null,
    "title": "Regicide",
    "traits": [
      "Abyssal",
      "Thunderspawn",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 5,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "All players reveal the top 5 cards from their decks. Destroy all revealed clerics. Discard the rest.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "abyssalThunderspawn"
  },
  {
    "id": "monster-tendril-minion",
    "type": "monster",
    "subtype": null,
    "title": "Tendril Minion",
    "traits": [
      "Abyssal",
      "Thunderspawn",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 1 disease. Gain 1 additional disease if a disease is present.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "abyssalThunderspawn"
  },
  {
    "id": "monster-usurper",
    "type": "monster",
    "subtype": null,
    "title": "Usurper",
    "traits": [
      "Abyssal",
      "Thunderspawn",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 1,
    "xp": 3,
    "points": 6,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy all but 2 heroes.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 village card.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "abyssalThunderspawn"
  },
  {
    "id": "monster-lavrik-ca",
    "type": "monster",
    "subtype": null,
    "title": "Lavrik-ca",
    "traits": [
      "Ancient One",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Reduce your Total Attack Value to 0.",
          "repeatable": false
        },
        {
          "text": "Reduce this card's Health by 2 for each point of Light present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ancientOnes"
  },
  {
    "id": "monster-stellar-weaver",
    "type": "monster",
    "subtype": null,
    "title": "Stellar Weaver",
    "traits": [
      "Ancient One",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "If there is Darkness in this rank, add Health +4.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ancientOnes"
  },
  {
    "id": "monster-penumbra-fiend",
    "type": "monster",
    "subtype": null,
    "title": "Penumbra Fiend",
    "traits": [
      "Ancient One",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 7,
    "light": -1,
    "level": 3,
    "xp": 3,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You cannot select this monster to fight if there is Darkness in this rank.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ancientOnes"
  },
  {
    "id": "monster-philethis",
    "type": "monster",
    "subtype": null,
    "title": "Philethis",
    "traits": [
      "Ancient One",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 12,
    "light": -1,
    "level": 3,
    "xp": 3,
    "points": 7,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "If you have 5 or more Light present, defeat this card.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ancientOnes"
  },
  {
    "id": "monster-syzygy-ghoul",
    "type": "monster",
    "subtype": null,
    "title": "Syzygy Ghoul",
    "traits": [
      "Ancient One",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 15,
    "level": 3,
    "xp": 3,
    "points": 8,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Draw 1 card for each point of Light present.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ancientOnes"
  },
  {
    "id": "monster-disassembler",
    "type": "monster",
    "subtype": null,
    "title": "Disassembler",
    "traits": [
      "Automaton",
      "Doomladen",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Resolve this card's Battle effect twice if a Doomladen is present (in your hand).",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy one mercenary or level 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "automatons"
  },
  {
    "id": "monster-zhev",
    "type": "monster",
    "subtype": null,
    "title": "Zhev",
    "traits": [
      "Automaton",
      "Doomladen",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 thief.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "automatons"
  },
  {
    "id": "monster-mastigophore",
    "type": "monster",
    "subtype": null,
    "title": "Mastigophore",
    "traits": [
      "Automaton",
      "Doomladen",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Resolve this card's Battle effect twice if a Doomladen is present (in your hand).",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 human hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "automatons"
  },
  {
    "id": "monster-dark-fathom",
    "type": "monster",
    "subtype": null,
    "title": "Dark Fathom",
    "traits": [
      "Automaton",
      "Doomladen",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 3,
    "points": 5,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Resolve this card's Battle effect twice if a Doomladen is present (in your hand).",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 wizard or cleric.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "automatons"
  },
  {
    "id": "monster-guardian-automaton",
    "type": "monster",
    "subtype": null,
    "title": "Guardian Automaton",
    "traits": [
      "Automaton",
      "Doomladen",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Add Health +4 if a monster is present (in your hand).",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 monster present (in your hand).",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "automatons"
  },
  {
    "id": "monster-blood-barm",
    "type": "monster",
    "subtype": null,
    "title": "Blood Barm",
    "traits": [
      "Beast",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Suffer Light -1.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "beasts"
  },
  {
    "id": "monster-thuman",
    "type": "monster",
    "subtype": null,
    "title": "Thuman",
    "traits": [
      "Beast",
      "Doomladen",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 4,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "beasts"
  },
  {
    "id": "monster-broken-hound",
    "type": "monster",
    "subtype": null,
    "title": "Broken Hound",
    "traits": [
      "Beast",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 3,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "beasts"
  },
  {
    "id": "monster-ithsyn",
    "type": "monster",
    "subtype": null,
    "title": "Ithsyn",
    "traits": [
      "Beast",
      "Doomladen",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to weapons other than bows.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "beasts"
  },
  {
    "id": "monster-seskii",
    "type": "monster",
    "subtype": null,
    "title": "Seskii",
    "traits": [
      "Beast",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "If a weapon is equipped, gain 1 disease.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "beasts"
  },
  {
    "id": "monster-mounted-raider",
    "type": "monster",
    "subtype": null,
    "title": "Mounted Raider",
    "traits": [
      "Bandit",
      "Raider",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 spell with an ability you have used.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 weapon or item with an ability you have used.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bandit"
  },
  {
    "id": "monster-bandit-taskmaster",
    "type": "monster",
    "subtype": null,
    "title": "Bandit Taskmaster",
    "traits": [
      "Bandit",
      "Raider",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Place 1 weapon and 1 item on top of your deck.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "You must use all Dungeon abilities (if possible).",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bandit"
  },
  {
    "id": "monster-bandit-killer",
    "type": "monster",
    "subtype": null,
    "title": "Bandit Killer",
    "traits": [
      "Bandit",
      "Raider",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Place 1 item on top of your deck.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bandit"
  },
  {
    "id": "monster-bandit-warlord",
    "type": "monster",
    "subtype": null,
    "title": "Bandit Warlord",
    "traits": [
      "Bandit",
      "Raider",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 8,
    "level": 2,
    "xp": 3,
    "points": 5,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy all items, weapons, and spells with abilities you have used.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bandit"
  },
  {
    "id": "monster-bandit-warrior",
    "type": "monster",
    "subtype": null,
    "title": "Bandit Warrior",
    "traits": [
      "Bandit",
      "Raider",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "You must use all Dungeon abilities (if possible).",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bandit"
  },
  {
    "id": "monster-red-gronek",
    "type": "monster",
    "subtype": null,
    "title": "Red Gronek",
    "traits": [
      "Behemoth",
      "Giant",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 11,
    "level": 3,
    "xp": 2,
    "points": 5,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 item.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "behemoth"
  },
  {
    "id": "monster-faceless-colossus",
    "type": "monster",
    "subtype": null,
    "title": "Faceless Colossus",
    "traits": [
      "Behemoth",
      "Giant",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 15,
    "level": 3,
    "xp": 3,
    "points": 7,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "behemoth"
  },
  {
    "id": "monster-hulking-yeti",
    "type": "monster",
    "subtype": null,
    "title": "Hulking Yeti",
    "traits": [
      "Behemoth",
      "Giant",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 11,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack Required.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "behemoth"
  },
  {
    "id": "monster-blue-gronek",
    "type": "monster",
    "subtype": null,
    "title": "Blue Gronek",
    "traits": [
      "Behemoth",
      "Giant",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 10,
    "level": 3,
    "xp": 2,
    "points": 5,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "behemoth"
  },
  {
    "id": "monster-cyclopic-horror",
    "type": "monster",
    "subtype": null,
    "title": "Cyclopic Horror",
    "traits": [
      "Behemoth",
      "Giant",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 13,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 village card.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "behemoth"
  },
  {
    "id": "monster-ophidian-cutter",
    "type": "monster",
    "subtype": null,
    "title": "Ophidian Cutter",
    "traits": [
      "Bestial",
      "Humanoid",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bestial"
  },
  {
    "id": "monster-gnoll-ravager",
    "type": "monster",
    "subtype": null,
    "title": "Gnoll Ravager",
    "traits": [
      "Bestial",
      "Humanoid",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Add Strength +2 to one Hero.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bestial"
  },
  {
    "id": "monster-kobold-meddler",
    "type": "monster",
    "subtype": null,
    "title": "Kobold Meddler",
    "traits": [
      "Bestial",
      "Humanoid",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 4,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 weapon.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bestial"
  },
  {
    "id": "monster-leonine-shredder",
    "type": "monster",
    "subtype": null,
    "title": "Leonine Shredder",
    "traits": [
      "Bestial",
      "Humanoid",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bestial"
  },
  {
    "id": "monster-orc-spiker",
    "type": "monster",
    "subtype": null,
    "title": "Orc Spiker",
    "traits": [
      "Bestial",
      "Humanoid",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 3,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 Regular.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [
        {
          "text": "Magic Attack +1.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "bestial"
  },
  {
    "id": "monster-charred-bruin",
    "type": "monster",
    "subtype": null,
    "title": "Charred Bruin",
    "traits": [
      "Burnmarked",
      "Fire",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each player destroys 1 card.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "burnmarked"
  },
  {
    "id": "monster-blazing-grimalkin",
    "type": "monster",
    "subtype": null,
    "title": "Blazing Grimalkin",
    "traits": [
      "Burnmarked",
      "Fire",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 3,
    "points": 3,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each player may choose to discard 3 cards. If a player chooses not to, that player loses 1 XP.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "burnmarked"
  },
  {
    "id": "monster-pyre-viper",
    "type": "monster",
    "subtype": null,
    "title": "Pyre Viper",
    "traits": [
      "Burnmarked",
      "Fire",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each player must either show a curse or gain 2 curses.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "burnmarked"
  },
  {
    "id": "monster-phoenix",
    "type": "monster",
    "subtype": null,
    "title": "Phoenix",
    "traits": [
      "Burnmarked",
      "Fire",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain a curse.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [
        {
          "text": "Gain 3 XP. Place Phoenix on top of the dungeon deck.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "burnmarked"
  },
  {
    "id": "monster-hellhound",
    "type": "monster",
    "subtype": null,
    "title": "Hellhound",
    "traits": [
      "Burnmarked",
      "Fire",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 1,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse. Each other player must discard 1 hero, or show a hand with none.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "If you did not defeat this card, gain 1 curse.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "burnmarked"
  },
  {
    "id": "monster-tenebrate",
    "type": "monster",
    "subtype": null,
    "title": "Tenebrate",
    "traits": [
      "Chiroptid",
      "Humanoid",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": [
        {
          "text": "If there is an Ambusher in the hall, destroy 1 card with a Light icon.",
          "repeatable": false
        }
      ]
    },
    "group": "chiroptid"
  },
  {
    "id": "monster-dusk-hunter",
    "type": "monster",
    "subtype": null,
    "title": "Dusk Hunter",
    "traits": [
      "Chiroptid",
      "Humanoid",
      "Ambusher",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 1,
    "xp": 3,
    "points": 4,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Reveal the top card of your deck. Add that card's gold cost to this card's Health.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "If you do not defeat this card, destroy the revealed card and lose 2 XP.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "chiroptid"
  },
  {
    "id": "monster-desmodic",
    "type": "monster",
    "subtype": null,
    "title": "Desmodic",
    "traits": [
      "Chiroptid",
      "Humanoid",
      "Level 1"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "If there is an Ambusher in the hall, each time a player visits the village, that player destroys the top card of 1 hero stack.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "chiroptid"
  },
  {
    "id": "monster-life-drinker",
    "type": "monster",
    "subtype": null,
    "title": "Life Drinker",
    "traits": [
      "Chiroptid",
      "Humanoid",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": [
        {
          "text": "If there is an Ambusher in the hall, lose 3 XP and destroy 1 card with a Light icon.",
          "repeatable": false
        }
      ]
    },
    "group": "chiroptid"
  },
  {
    "id": "monster-darkling",
    "type": "monster",
    "subtype": null,
    "title": "Darkling",
    "traits": [
      "Chiroptid",
      "Humanoid",
      "Ambusher",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Reveal the top card of your deck. Add that card's gold cost to this card's Health. If the card has a Light icon, destroy it.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "chiroptid"
  },
  {
    "id": "monster-blackflock-conniver",
    "type": "monster",
    "subtype": null,
    "title": "Blackflock Conniver",
    "traits": [
      "Corvaxis",
      "Avian",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "If any Ambushers are in the hall, discard all equipped weapons.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "corvaxis"
  },
  {
    "id": "monster-slaughterwing",
    "type": "monster",
    "subtype": null,
    "title": "Slaughterwing",
    "traits": [
      "Corvaxis",
      "Avian",
      "Ambusher",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 2,
    "xp": 3,
    "points": 5,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Reveal the top card of the active player's deck. Add its gold cost to this card's Health. If it is a hero of level 2 or lower, destroy it.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "corvaxis"
  },
  {
    "id": "monster-plunderwing",
    "type": "monster",
    "subtype": null,
    "title": "Plunderwing",
    "traits": [
      "Corvaxis",
      "Avian",
      "Ambusher",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 2,
    "xp": 3,
    "points": 4,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Reveal the top card of the active player's deck. Add its gold cost to this card's Health. If it is a weapon or item, destroy it.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "corvaxis"
  },
  {
    "id": "monster-blackflock-ravener",
    "type": "monster",
    "subtype": null,
    "title": "Blackflock Ravener",
    "traits": [
      "Corvaxis",
      "Avian",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": [
        {
          "text": "The active player destroys 1 card present.",
          "repeatable": false
        }
      ]
    },
    "group": "corvaxis"
  },
  {
    "id": "monster-blackflock-assassin",
    "type": "monster",
    "subtype": null,
    "title": "Blackflock Assassin",
    "traits": [
      "Corvaxis",
      "Avian",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": [
        {
          "text": "If any Ambushers are in the hall, the active player destroys 1 hero.",
          "repeatable": false
        }
      ]
    },
    "group": "corvaxis"
  },
  {
    "id": "monster-minion-of-discord",
    "type": "monster",
    "subtype": null,
    "title": "Minion of Discord",
    "traits": [
      "Djinnbound",
      "Corrupted",
      "Level 1"
    ],
    "goldValue": 0,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [
        {
          "text": "Add Physical Attack +1",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinnbound"
  },
  {
    "id": "monster-minion-of-decay",
    "type": "monster",
    "subtype": null,
    "title": "Minion of Decay",
    "traits": [
      "Djinnbound",
      "Corrupted",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 3,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Add Health equal to the number of heroes present.",
          "repeatable": false
        },
        {
          "text": "Gain 1 curse.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [
        {
          "text": "Destroy 1 disease to draw 1 card.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinnbound"
  },
  {
    "id": "monster-minion-of-horror",
    "type": "monster",
    "subtype": null,
    "title": "Minion of Horror",
    "traits": [
      "Djinnbound",
      "Corrupted",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 4,
    "light": 1,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You cannot select this monster to fight if there is Darkness in this rank.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinnbound"
  },
  {
    "id": "monster-minion-of-war",
    "type": "monster",
    "subtype": null,
    "title": "Minion of War",
    "traits": [
      "Djinnbound",
      "Corrupted",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 1,
    "xp": 2,
    "points": 4,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 card.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinnbound"
  },
  {
    "id": "monster-minion-of-neglect",
    "type": "monster",
    "subtype": null,
    "title": "Minion of Neglect",
    "traits": [
      "Djinnbound",
      "Corrupted",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 4,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Draw 1 fewer card when you refill your hand at the end of the turn.",
          "repeatable": false
        }
      ],
      "trophy": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinnbound"
  },
  {
    "id": "monster-ghul",
    "type": "monster",
    "subtype": null,
    "title": "Ghul",
    "traits": [
      "Djinni",
      "Efreet",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to fighters and edged weapons.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse if you have no fighter.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinni"
  },
  {
    "id": "monster-ifrit",
    "type": "monster",
    "subtype": null,
    "title": "Ifrit",
    "traits": [
      "Djinni",
      "Efreet",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 3,
    "xp": 2,
    "points": 5,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to rangers and bow weapons.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse if you have no ranger.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinni"
  },
  {
    "id": "monster-iblis",
    "type": "monster",
    "subtype": null,
    "title": "Iblis",
    "traits": [
      "Djinni",
      "Efreet",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 12,
    "level": 3,
    "xp": 3,
    "points": 7,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to clerics.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse if you have no cleric. Cancel all Light that is not provided by heroes.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinni"
  },
  {
    "id": "monster-marid",
    "type": "monster",
    "subtype": null,
    "title": "Marid",
    "traits": [
      "Djinni",
      "Efreet",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 10,
    "level": 3,
    "xp": 2,
    "points": 6,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to thieves.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse if you have no thief. Cancel all Spoils abilities.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinni"
  },
  {
    "id": "monster-majnun",
    "type": "monster",
    "subtype": null,
    "title": "Majnun",
    "traits": [
      "Djinni",
      "Efreet",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 3,
    "xp": 2,
    "points": 5,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to wizards and spells.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse if you have no wizard.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "djinni"
  },
  {
    "id": "monster-lord-mortis",
    "type": "monster",
    "subtype": null,
    "title": "Lord Mortis",
    "traits": [
      "Doomknight",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 2,
    "xp": 1,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Suffer Light -1.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "doomknightHumanoid"
  },
  {
    "id": "monster-the-prince",
    "type": "monster",
    "subtype": null,
    "title": "The Prince",
    "traits": [
      "Doomknight",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 5,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each hero suffers Strength -2.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 fighter.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "doomknightHumanoid"
  },
  {
    "id": "monster-judgement",
    "type": "monster",
    "subtype": null,
    "title": "Judgement",
    "traits": [
      "Doomknight",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 2,
    "xp": 1,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each hero suffers Physical Attack -1 and Strength -2.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "doomknightHumanoid"
  },
  {
    "id": "monster-knightmare",
    "type": "monster",
    "subtype": null,
    "title": "Knightmare",
    "traits": [
      "Doomknight",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 8,
    "level": 2,
    "xp": 3,
    "points": 6,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Suffer Light -2.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 fighter.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "doomknightHumanoid"
  },
  {
    "id": "monster-darkness",
    "type": "monster",
    "subtype": null,
    "title": "Darkness",
    "traits": [
      "Doomknight",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Ignore unequipped heroes.",
          "repeatable": false
        },
        {
          "text": "Suffer Light -1.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "doomknightHumanoid"
  },
  {
    "id": "monster-legion-general",
    "type": "monster",
    "subtype": null,
    "title": "Legion General",
    "traits": [
      "Doomknight",
      "Undead",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 11,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Cannot be fought unless 2 or more monsters are present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "doomknightUndead"
  },
  {
    "id": "monster-legion-warrior",
    "type": "monster",
    "subtype": null,
    "title": "Legion Warrior",
    "traits": [
      "Doomknight",
      "Undead",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to unequipped heroes.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Add Health +2 if at least 1 monster is present.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "doomknightUndead"
  },
  {
    "id": "monster-legion-sorcerer",
    "type": "monster",
    "subtype": null,
    "title": "Legion Sorcerer",
    "traits": [
      "Doomknight",
      "Undead",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 3,
    "xp": 3,
    "points": 7,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack required.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 hero or village card for each monster present.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "doomknightUndead"
  },
  {
    "id": "monster-legion-necromancer",
    "type": "monster",
    "subtype": null,
    "title": "Legion Necromancer",
    "traits": [
      "Doomknight",
      "Undead",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Add Health +2 for each monster present.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "doomknightUndead"
  },
  {
    "id": "monster-ebon-fume",
    "type": "monster",
    "subtype": null,
    "title": "Ebon Fume",
    "traits": [
      "Dragon",
      "Chromatic",
      "Level 3"
    ],
    "goldValue": 1,
    "health": 11,
    "level": 3,
    "xp": 3,
    "points": 8,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero with the highest Strength.",
          "repeatable": false
        }
      ],
      "trophy": [
        {
          "text": "Physical Attack +3.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonChromatic"
  },
  {
    "id": "monster-skaladak",
    "type": "monster",
    "subtype": null,
    "title": "Skaladak",
    "traits": [
      "Dragon",
      "Chromatic",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 7,
    "level": 3,
    "xp": 2,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonChromatic"
  },
  {
    "id": "monster-mythlurian",
    "type": "monster",
    "subtype": null,
    "title": "Mythlurian",
    "traits": [
      "Dragon",
      "Chromatic",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 8,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonChromatic"
  },
  {
    "id": "monster-tyxr-the-old",
    "type": "monster",
    "subtype": null,
    "title": "Tyxr the Old",
    "traits": [
      "Dragon",
      "Chromatic",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 10,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "trophy": [
        {
          "text": "Magic Attack +2.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Each player discards 2 cards.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "dragonChromatic"
  },
  {
    "id": "monster-uyril-unending",
    "type": "monster",
    "subtype": null,
    "title": "Uyril Unending",
    "traits": [
      "Dragon",
      "Chromatic",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 3,
    "xp": 2,
    "points": 5,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Halve Total Attack Value (round down) unless Magic Attack is present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 Regular.",
          "repeatable": false
        }
      ],
      "trophy": [
        {
          "text": "Physical Attack +1.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonChromatic"
  },
  {
    "id": "monster-cinder-drake",
    "type": "monster",
    "subtype": null,
    "title": "Cinder Drake",
    "traits": [
      "Dragon",
      "Fire",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 10,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 spell.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonFire"
  },
  {
    "id": "monster-caldera-dragon",
    "type": "monster",
    "subtype": null,
    "title": "Caldera Dragon",
    "traits": [
      "Dragon",
      "Fire",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 11,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "After each time a player uses an ability that drew 1 or more cards, that player must discard 1 card.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonFire"
  },
  {
    "id": "monster-smokeplume-drake",
    "type": "monster",
    "subtype": null,
    "title": "Smokeplume Drake",
    "traits": [
      "Dragon",
      "Fire",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 9,
    "light": -3,
    "level": 3,
    "xp": 2,
    "points": 7,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 2 cards.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 hero with the highest strength.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonFire"
  },
  {
    "id": "monster-ash-dragon",
    "type": "monster",
    "subtype": null,
    "title": "Ash Dragon",
    "traits": [
      "Dragon",
      "Fire",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard all heroes of level 1 or lower.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy all items and weapons that provide Light.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonFire"
  },
  {
    "id": "monster-magma-wyrm",
    "type": "monster",
    "subtype": null,
    "title": "Magma Wyrm",
    "traits": [
      "Dragon",
      "Fire",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "After a player visits the village, this card switches ranks with the monster in front of it.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Destroy the top 2 cards of each village and hero stack.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "dragonFire"
  },
  {
    "id": "monster-skywyrm-overlord",
    "type": "monster",
    "subtype": null,
    "title": "Skywyrm Overlord",
    "traits": [
      "Dragon",
      "Humanoid",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 7,
    "level": 3,
    "xp": 3,
    "points": 7,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Ignore 1 hero for each class present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy each hero that was ignored.",
          "repeatable": false
        },
        {
          "text": "If not defeated, place this card in the dungeon deck as the third card down.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonHumanoid"
  },
  {
    "id": "monster-skywyrm-scavenger",
    "type": "monster",
    "subtype": null,
    "title": "Skywyrm Scavenger",
    "traits": [
      "Dragon",
      "Humanoid",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Ignore thieves and rangers.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 Regular.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonHumanoid"
  },
  {
    "id": "monster-skywyrm-mage",
    "type": "monster",
    "subtype": null,
    "title": "Skywyrm Mage",
    "traits": [
      "Dragon",
      "Humanoid",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 3,
    "xp": 1,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 fighter.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonHumanoid"
  },
  {
    "id": "monster-skywyrm-warrior",
    "type": "monster",
    "subtype": null,
    "title": "Skywyrm Warrior",
    "traits": [
      "Dragon",
      "Humanoid",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 3,
    "xp": 2,
    "points": 5,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Ignore fighters.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 wizard.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonHumanoid"
  },
  {
    "id": "monster-skywyrm-priest",
    "type": "monster",
    "subtype": null,
    "title": "Skywyrm Priest",
    "traits": [
      "Dragon",
      "Humanoid",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 3,
    "xp": 1,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Ignore clerics.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 Regular.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "dragonHumanoid"
  },
  {
    "id": "monster-rockslide",
    "type": "monster",
    "subtype": null,
    "title": "Rockslide",
    "traits": [
      "Elemental",
      "Earth",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Destroy the top card of each hero stack. Move this monster to the highest rank (once per turn).",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "elementalEarth"
  },
  {
    "id": "monster-aftershock",
    "type": "monster",
    "subtype": null,
    "title": "Aftershock",
    "traits": [
      "Elemental",
      "Earth",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 8,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack required.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero with Magic Attack.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "elementalEarth"
  },
  {
    "id": "monster-eruptor",
    "type": "monster",
    "subtype": null,
    "title": "Eruptor",
    "traits": [
      "Elemental",
      "Earth",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 11,
    "level": 3,
    "xp": 2,
    "points": 7,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack required.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy the hero with the lowest Strength.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "elementalEarth"
  },
  {
    "id": "monster-scree",
    "type": "monster",
    "subtype": null,
    "title": "Scree",
    "traits": [
      "Elemental",
      "Earth",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 10,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to edged weapons.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Destroy the top card of each weapon stack. Move this monster to the highest rank (once per turn).",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "elementalEarth"
  },
  {
    "id": "monster-tremorfiend",
    "type": "monster",
    "subtype": null,
    "title": "Tremorfiend",
    "traits": [
      "Elemental",
      "Earth",
      "Level 3"
    ],
    "goldValue": 1,
    "health": 8,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to heroes with 4 Strength or less.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Destroy the top card of each spell stack. Move this monster to the highest rank (once per turn).",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "elementalEarth"
  },
  {
    "id": "monster-blood-torment",
    "type": "monster",
    "subtype": null,
    "title": "Blood Torment",
    "traits": [
      "Elemental",
      "Pain",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 9,
    "level": 3,
    "xp": 3,
    "points": 8,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each player shows his or her hand and destroys 1 revealed monster (if any).",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "All players reveal the top 5 cards from their decks. Each player destroys 1 revealed card with a VP value (if any). Discard the rest.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "elementalPain"
  },
  {
    "id": "monster-steam-torment",
    "type": "monster",
    "subtype": null,
    "title": "Steam Torment",
    "traits": [
      "Elemental",
      "Pain",
      "Level 3"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 3,
    "xp": 1,
    "points": 3,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Physical Attack +1.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [
        {
          "text": "Monsters will not leave the hall unless defeated.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "elementalPain"
  },
  {
    "id": "monster-lava-torment",
    "type": "monster",
    "subtype": null,
    "title": "Lava Torment",
    "traits": [
      "Elemental",
      "Pain",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 3,
    "xp": 2,
    "points": 5,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "All players reveal the top 5 cards from their decks. Each player destroys one revealed level 1 hero (if any). Discard the rest.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "elementalPain"
  },
  {
    "id": "monster-smoke-torment",
    "type": "monster",
    "subtype": null,
    "title": "Smoke Torment",
    "traits": [
      "Elemental",
      "Pain",
      "Level 3"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 3,
    "xp": 1,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Physical Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "All players reveal the top 5 cards from their decks. Each player destroys 1 revealed Regular (if any). Discard the rest.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "elementalPain"
  },
  {
    "id": "monster-shadow-torment",
    "type": "monster",
    "subtype": null,
    "title": "Shadow Torment",
    "traits": [
      "Elemental",
      "Pain",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 3,
    "xp": 2,
    "points": 6,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Physical Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "All players reveal the top 5 cards from their decks. Each player destroys one revealed level 2 hero (if any). Discard the rest.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "elementalPain"
  },
  {
    "id": "monster-geyser-salamander",
    "type": "monster",
    "subtype": null,
    "title": "Geyser Salamander",
    "traits": [
      "Elemental",
      "Salamander",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 7,
    "level": 2,
    "xp": 3,
    "points": 5,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Draw 1 card. If it is not a hero, add Health +2 and destroy 1 hero with the highest Strength.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "elementalSalamander"
  },
  {
    "id": "monster-steam-salamander",
    "type": "monster",
    "subtype": null,
    "title": "Steam Salamander",
    "traits": [
      "Elemental",
      "Salamander",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 4,
    "level": 2,
    "xp": 1,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Draw 1 card. If it is not a hero, add Health +2.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "elementalSalamander"
  },
  {
    "id": "monster-molten-salamander",
    "type": "monster",
    "subtype": null,
    "title": "Molten Salamander",
    "traits": [
      "Elemental",
      "Salamander",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Draw 1 card. If it is not a weapon, add Health +2 and destroy a fighter or weapon.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "elementalSalamander"
  },
  {
    "id": "monster-fume-salamander",
    "type": "monster",
    "subtype": null,
    "title": "Fume Salamander",
    "traits": [
      "Elemental",
      "Salamander",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Draw 1 card. If it is not an item, add Health +2 and destroy a thief or item.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "elementalSalamander"
  },
  {
    "id": "monster-sulphur-salamander",
    "type": "monster",
    "subtype": null,
    "title": "Sulphur Salamander",
    "traits": [
      "Elemental",
      "Salamander",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Draw 1 card. If it is not a spell, add Health +2 and destroy a wizard or spell.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "elementalSalamander"
  },
  {
    "id": "monster-frost-giant",
    "type": "monster",
    "subtype": null,
    "title": "Frost Giant",
    "traits": [
      "Giant",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 5,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 2 heroes with Strength 5 or lower. Destroy 1 weapon with the lowest Weight.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "giant"
  },
  {
    "id": "monster-stone-giant",
    "type": "monster",
    "subtype": null,
    "title": "Stone Giant",
    "traits": [
      "Giant",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 2 heroes with Strength 4 or lower.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "giant"
  },
  {
    "id": "monster-titan",
    "type": "monster",
    "subtype": null,
    "title": "Titan",
    "traits": [
      "Giant",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 2,
    "xp": 3,
    "points": 6,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy all heroes except the 2 with the highest Strength. Destroy all weapons except 1 with the highest Weight.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "giant"
  },
  {
    "id": "monster-mountain-giant",
    "type": "monster",
    "subtype": null,
    "title": "Mountain Giant",
    "traits": [
      "Giant",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 1,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero with the lowest Strength.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "giant"
  },
  {
    "id": "monster-fire-giant",
    "type": "monster",
    "subtype": null,
    "title": "Fire Giant",
    "traits": [
      "Giant",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 2,
    "xp": 1,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero with the lowest Strength.",
          "repeatable": false
        }
      ],
      "trophy": [
        {
          "text": "Add Strength +3 to one hero.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "giant"
  },
  {
    "id": "monster-thieving-cur",
    "type": "monster",
    "subtype": null,
    "title": "Thieving Cur",
    "traits": [
      "Gnoll",
      "Humanoid",
      "Ambusher",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Randomly select and reveal 3 cards from your discard pile. Each weapon revealed adds Health +1. Destroy one of the revealed weapons.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "gnoll"
  },
  {
    "id": "monster-packhunter-gnoll",
    "type": "monster",
    "subtype": null,
    "title": "Packhunter Gnoll",
    "traits": [
      "Gnoll",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 2,
    "xp": 1,
    "points": 3,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "If any Ambushers are in the hall, each hero suffers Attack -1.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "gnoll"
  },
  {
    "id": "monster-marauder-gnoll",
    "type": "monster",
    "subtype": null,
    "title": "Marauder Gnoll",
    "traits": [
      "Gnoll",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": [
        {
          "text": "If any Ambushers are in the hall, destroy 1 item, weapon, or spell.",
          "repeatable": false
        }
      ]
    },
    "group": "gnoll"
  },
  {
    "id": "monster-alpha-gnoll",
    "type": "monster",
    "subtype": null,
    "title": "Alpha Gnoll",
    "traits": [
      "Gnoll",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "gnoll"
  },
  {
    "id": "monster-scavenging-cur",
    "type": "monster",
    "subtype": null,
    "title": "Scavenging Cur",
    "traits": [
      "Gnoll",
      "Humanoid",
      "Ambusher",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Randomly select and reveal 3 cards from your discard pile. Each item revealed adds Health +1. Destroy one of the revealed items.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "gnoll"
  },
  {
    "id": "monster-horde",
    "type": "monster",
    "subtype": null,
    "title": "Horde",
    "traits": [
      "Horde",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 3,
    "level": 2,
    "xp": 1,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Each Horde is worth a number of Victory Points equal to the number of Horde in your Party Deck (including this one) at the end of the game.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "horde"
  },
  {
    "id": "monster-night-howler",
    "type": "monster",
    "subtype": null,
    "title": "Night Howler",
    "traits": [
      "Horror",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 3,
    "xp": 3,
    "points": 7,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack or Physical Attack, whichever is higher.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "horrors"
  },
  {
    "id": "monster-erynth-grask",
    "type": "monster",
    "subtype": null,
    "title": "Erynth Grask",
    "traits": [
      "Horror",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 3,
    "xp": 3,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack Required",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "horrors"
  },
  {
    "id": "monster-yellow-swarm",
    "type": "monster",
    "subtype": null,
    "title": "Yellow Swarm",
    "traits": [
      "Horror",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 10,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "horrors"
  },
  {
    "id": "monster-edacious-destroyer",
    "type": "monster",
    "subtype": null,
    "title": "Edacious Destroyer",
    "traits": [
      "Horror",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack or Physical Attack, whichever is lower.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "horrors"
  },
  {
    "id": "monster-tetrahydra",
    "type": "monster",
    "subtype": null,
    "title": "Tetrahydra",
    "traits": [
      "Horror",
      "Level 3"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack Required",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 weapon.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "horrors"
  },
  {
    "id": "monster-discord-incarnate",
    "type": "monster",
    "subtype": null,
    "title": "Discord Incarnate",
    "traits": [
      "Incarnate",
      "Abyssal",
      "Level 3"
    ],
    "goldValue": 0,
    "health": 5,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Reveal the top card of your deck. Add its gold cost to this card's Health. If it has a gold cost, destroy it.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [
        {
          "text": "Cards cost 1 extra gold.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "incarnate"
  },
  {
    "id": "monster-decay-incarnate",
    "type": "monster",
    "subtype": null,
    "title": "Decay Incarnate",
    "traits": [
      "Incarnate",
      "Abyssal",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 3,
    "xp": 2,
    "points": 5,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack required",
          "repeatable": false
        },
        {
          "text": "Magic Attack required",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Each hero suffers Attack -1.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "incarnate"
  },
  {
    "id": "monster-horror-incarnate",
    "type": "monster",
    "subtype": null,
    "title": "Horror Incarnate",
    "traits": [
      "Incarnate",
      "Abyssal",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 8,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Add Health +2 if there is Darkness in this rank.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [
        {
          "text": "Gain 1 curse.",
          "repeatable": false
        }
      ],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "incarnate"
  },
  {
    "id": "monster-war-incarnate",
    "type": "monster",
    "subtype": null,
    "title": "War Incarnate",
    "traits": [
      "Incarnate",
      "Abyssal",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 11,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You can only select this monster to fight if you have an equipped hero.",
          "repeatable": false
        },
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Ignore 1 hero with the highest Strength.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "incarnate"
  },
  {
    "id": "monster-neglect-incarnate",
    "type": "monster",
    "subtype": null,
    "title": "Neglect Incarnate",
    "traits": [
      "Incarnate",
      "Abyssal",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 8,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each hero suffers Strength -3.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 hero with Strength lower than that hero's level.",
          "repeatable": false
        }
      ],
      "trophy": [
        {
          "text": "Discard down to 5 cards. You draw 1 fewer card when you draw cards.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "incarnate"
  },
  {
    "id": "monster-tactile-host",
    "type": "monster",
    "subtype": null,
    "title": "Tactile Host",
    "traits": [
      "Infected",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 9,
    "level": 2,
    "xp": 3,
    "points": 5,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Place 1 Doomladen present (in your hand) on the bottom of the dungeon deck.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "infected"
  },
  {
    "id": "monster-terror-bird",
    "type": "monster",
    "subtype": null,
    "title": "Terror Bird",
    "traits": [
      "Infected",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "If a Doomladen is present (in your hand), you must select a Terror Bird to fight.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "infected"
  },
  {
    "id": "monster-ravage-bear",
    "type": "monster",
    "subtype": null,
    "title": "Ravage Bear",
    "traits": [
      "Infected",
      "Doomladen",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each hero suffers Physical Attack -1 for each monster present (in your hand).",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "infected"
  },
  {
    "id": "monster-warrior-host",
    "type": "monster",
    "subtype": null,
    "title": "Warrior Host",
    "traits": [
      "Infected",
      "Doomladen",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "If a Doomladen is present (in your hand), gain 2 diseases.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "infected"
  },
  {
    "id": "monster-ocular-host",
    "type": "monster",
    "subtype": null,
    "title": "Ocular Host",
    "traits": [
      "Infected",
      "Doomladen",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": [
        {
          "text": "If a Doomladen is present (in your hand), place it on the bottom of the dungeon deck.",
          "repeatable": false
        }
      ]
    },
    "group": "infected"
  },
  {
    "id": "monster-drakeclan-cutter",
    "type": "monster",
    "subtype": null,
    "title": "Drakeclan Cutter",
    "traits": [
      "Kobold",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": -1,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "When you defeat this monster, you may place it into any player's discard pile.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "kobold"
  },
  {
    "id": "monster-drakeclan-ambusher",
    "type": "monster",
    "subtype": null,
    "title": "Drakeclan Ambusher",
    "traits": [
      "Kobold",
      "Ambusher",
      "Level 1"
    ],
    "goldValue": 0,
    "health": 4,
    "level": 1,
    "xp": 1,
    "points": 1,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "When you defeat this monster, you may place it into any player's discard pile.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "kobold"
  },
  {
    "id": "monster-drakeclan-laird",
    "type": "monster",
    "subtype": null,
    "title": "Drakeclan Laird",
    "traits": [
      "Kobold",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "This card gains Health equal to the total Health of all other kobolds in the hall. If you defeat this card, you also defeat each other kobold in the hall. You do not get XP for those kobolds.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "kobold"
  },
  {
    "id": "monster-drakeclan-shaman",
    "type": "monster",
    "subtype": null,
    "title": "Drakeclan Shaman",
    "traits": [
      "Kobold",
      "Level 1"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 1,
    "xp": 1,
    "points": -2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "When you defeat this monster, you may place it into any player's discard pile.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "kobold"
  },
  {
    "id": "monster-callerail",
    "type": "monster",
    "subtype": null,
    "title": "Callerail",
    "traits": [
      "Monstrosity",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 9,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "monstrosity"
  },
  {
    "id": "monster-mesomeme",
    "type": "monster",
    "subtype": null,
    "title": "Mesomeme",
    "traits": [
      "Monstrosity",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 item.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "monstrosity"
  },
  {
    "id": "monster-cragworm",
    "type": "monster",
    "subtype": null,
    "title": "Cragworm",
    "traits": [
      "Monstrosity",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 9,
    "level": 3,
    "xp": 3,
    "points": 7,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "monstrosity"
  },
  {
    "id": "monster-travonis-ul",
    "type": "monster",
    "subtype": null,
    "title": "Travonis Ul",
    "traits": [
      "Monstrosity",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 3,
    "xp": 3,
    "points": 5,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 2 heroes.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "monstrosity"
  },
  {
    "id": "monster-jiriskar",
    "type": "monster",
    "subtype": null,
    "title": "Jiriskar",
    "traits": [
      "Monstrosity",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 3,
    "xp": 3,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 weapon and 1 item.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "monstrosity"
  },
  {
    "id": "monster-ogrillon",
    "type": "monster",
    "subtype": null,
    "title": "Ogrillon",
    "traits": [
      "Ogre",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 equipped weapon.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ogre"
  },
  {
    "id": "monster-ogre",
    "type": "monster",
    "subtype": null,
    "title": "Ogre",
    "traits": [
      "Ogre",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero with Strength 3 or less.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ogre"
  },
  {
    "id": "monster-ettin",
    "type": "monster",
    "subtype": null,
    "title": "Ettin",
    "traits": [
      "Ogre",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 9,
    "level": 2,
    "xp": 2,
    "points": 5,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 hero without Magic Attack.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 hero without Physical Attack.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ogre"
  },
  {
    "id": "monster-ogre-mage",
    "type": "monster",
    "subtype": null,
    "title": "Ogre Mage",
    "traits": [
      "Ogre",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 card with Magic Attack.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 hero with Strength 4 or less.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ogre"
  },
  {
    "id": "monster-black-slime",
    "type": "monster",
    "subtype": null,
    "title": "Black Slime",
    "traits": [
      "Ooze",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 Regular.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ooze"
  },
  {
    "id": "monster-green-blob",
    "type": "monster",
    "subtype": null,
    "title": "Green Blob",
    "traits": [
      "Ooze",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 food.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ooze"
  },
  {
    "id": "monster-red-jelly",
    "type": "monster",
    "subtype": null,
    "title": "Red Jelly",
    "traits": [
      "Ooze",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 6,
    "light": 1,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ooze"
  },
  {
    "id": "monster-gray-ooze",
    "type": "monster",
    "subtype": null,
    "title": "Gray Ooze",
    "traits": [
      "Ooze",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero unless at least 1 weapon is equipped.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 food.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "ooze"
  },
  {
    "id": "monster-noxious-slag",
    "type": "monster",
    "subtype": null,
    "title": "Noxious Slag",
    "traits": [
      "Ooze",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 7,
    "level": 1,
    "xp": 2,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to edged weapons.",
          "repeatable": false
        },
        {
          "text": "Halve Magic Attack (round down).",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ooze"
  },
  {
    "id": "monster-greater-viscoid",
    "type": "monster",
    "subtype": null,
    "title": "Greater Viscoid",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-blue-viscoid",
    "type": "monster",
    "subtype": null,
    "title": "Blue Viscoid",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 3,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to edged weapons, polearm weapons, and Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-slithering-ooze",
    "type": "monster",
    "subtype": null,
    "title": "Slithering Ooze",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy one hero of level 1 or lower.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-red-viscoid",
    "type": "monster",
    "subtype": null,
    "title": "Red Viscoid",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack required.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-green-viscoid",
    "type": "monster",
    "subtype": null,
    "title": "Green Viscoid",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to edged weapons and polearm weapons.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-gelatinous-cube",
    "type": "monster",
    "subtype": null,
    "title": "Gelatinous Cube",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-stalking-stalactite",
    "type": "monster",
    "subtype": null,
    "title": "Stalking Stalactite",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 7,
    "level": 1,
    "xp": 2,
    "points": 4,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack required.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-black-viscoid",
    "type": "monster",
    "subtype": null,
    "title": "Black Viscoid",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to edged weapons and polearm weapons.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-mucilaginous-mass",
    "type": "monster",
    "subtype": null,
    "title": "Mucilaginous Mass",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-jelly-blebs",
    "type": "monster",
    "subtype": null,
    "title": "Jelly Blebs",
    "traits": [
      "Ooze",
      "Cavern",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "oozeCavern"
  },
  {
    "id": "monster-huntsman",
    "type": "monster",
    "subtype": null,
    "title": "Huntsman",
    "traits": [
      "Royal Guard",
      "Corrupted",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 5,
    "level": 2,
    "xp": 2,
    "points": 2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Reveal the top card of the active player's deck. Each hero suffers Strength penalty equal to its gold cost. If it is a weapon or item, destroy it.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "royalGuard"
  },
  {
    "id": "monster-guardsman",
    "type": "monster",
    "subtype": null,
    "title": "Guardsman",
    "traits": [
      "Royal Guard",
      "Corrupted",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Each hero suffers Strength -6.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 fighter with 0 Strength.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "royalGuard"
  },
  {
    "id": "monster-weapons-master",
    "type": "monster",
    "subtype": null,
    "title": "Weapons Master",
    "traits": [
      "Royal Guard",
      "Corrupted",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Each hero suffers Strength -2.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy any unequipped weapons.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "royalGuard"
  },
  {
    "id": "monster-chiurgeon",
    "type": "monster",
    "subtype": null,
    "title": "Chiurgeon",
    "traits": [
      "Royal Guard",
      "Corrupted",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Each hero suffers Strength -2.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 hero with Strength less than that hero's level.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "royalGuard"
  },
  {
    "id": "monster-guard-captain",
    "type": "monster",
    "subtype": null,
    "title": "Guard Captain",
    "traits": [
      "Royal Guard",
      "Corrupted",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 5,
    "level": 2,
    "xp": 3,
    "points": 4,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        },
        {
          "text": "Each hero suffers Attack -1 and Strength -2.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 unequipped hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "royalGuard"
  },
  {
    "id": "monster-spider-queen",
    "type": "monster",
    "subtype": null,
    "title": "Spider Queen",
    "traits": [
      "Spider",
      "Animal",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 3,
    "points": 8,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 2 heroes.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "spider"
  },
  {
    "id": "monster-firefang",
    "type": "monster",
    "subtype": null,
    "title": "Firefang",
    "traits": [
      "Spider",
      "Animal",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 4,
    "level": 2,
    "xp": 1,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Each player destroys 1 hero or shows a hand with none.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "spider"
  },
  {
    "id": "monster-dread",
    "type": "monster",
    "subtype": null,
    "title": "Dread",
    "traits": [
      "Spider",
      "Animal",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 5,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "The active player destroys all heroes present.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "spider"
  },
  {
    "id": "monster-green-spinner",
    "type": "monster",
    "subtype": null,
    "title": "Green Spinner",
    "traits": [
      "Spider",
      "Animal",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 5,
    "level": 2,
    "xp": 1,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Each player destroys 2 heroes or shows a hand with fewer. If only 1 hero is shown, destroy it.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "spider"
  },
  {
    "id": "monster-widowmaker",
    "type": "monster",
    "subtype": null,
    "title": "Widowmaker",
    "traits": [
      "Spider",
      "Animal",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Ignore 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Each player destroys 1 hero or shows a hand with none.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "spider"
  },
  {
    "id": "monster-troll-skullcracker",
    "type": "monster",
    "subtype": null,
    "title": "Troll Skullcracker",
    "traits": [
      "Troll",
      "Humanoid",
      "Ambusher",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Does not leave the hall after a player loses a combat against this card.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": [
        {
          "text": "The next player must enter the dungeon and fight this card.",
          "repeatable": false
        }
      ]
    },
    "group": "troll"
  },
  {
    "id": "monster-troll-osteomancer",
    "type": "monster",
    "subtype": null,
    "title": "Troll Osteomancer",
    "traits": [
      "Troll",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 2,
    "xp": 2,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Does not leave the hall after a player loses a combat against this card.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 hero unless a curse is present.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "troll"
  },
  {
    "id": "monster-troll-bonebreaker",
    "type": "monster",
    "subtype": null,
    "title": "Troll Bonebreaker",
    "traits": [
      "Troll",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 2,
    "xp": 3,
    "points": 3,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Does not leave the hall after a player loses a combat against this card.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 weapon.",
          "repeatable": false
        },
        {
          "text": "Gain 1 curse.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "troll"
  },
  {
    "id": "monster-troll-marrowgaunt",
    "type": "monster",
    "subtype": null,
    "title": "Troll Marrowgaunt",
    "traits": [
      "Troll",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Does not leave the hall after a player loses a combat against this card.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 2 curses.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "troll"
  },
  {
    "id": "monster-troll-spinecutter",
    "type": "monster",
    "subtype": null,
    "title": "Troll Spinecutter",
    "traits": [
      "Troll",
      "Humanoid",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Does not leave the hall after a player loses a combat against this card.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 curse.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "troll"
  },
  {
    "id": "monster-ellnoica",
    "type": "monster",
    "subtype": null,
    "title": "Ellnoica",
    "traits": [
      "Ultraterrestrial",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You cannot defeat this card with 10 or higher Total Attack Value.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ultraterrestrial"
  },
  {
    "id": "monster-nibovian-wife",
    "type": "monster",
    "subtype": null,
    "title": "Nibovian Wife",
    "traits": [
      "Ultraterrestrial",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 3,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You cannot defeat this card with 10 or higher Total Attack Value.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ultraterrestrial"
  },
  {
    "id": "monster-pallone",
    "type": "monster",
    "subtype": null,
    "title": "Pallone",
    "traits": [
      "Ultraterrestrial",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You cannot defeat this card with 9 or higher Total Attack Value.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ultraterrestrial"
  },
  {
    "id": "monster-abykos",
    "type": "monster",
    "subtype": null,
    "title": "Abykos",
    "traits": [
      "Ultraterrestrial",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You cannot defeat this card with 10 or higher Total Attack Value.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ultraterrestrial"
  },
  {
    "id": "monster-jurulisk",
    "type": "monster",
    "subtype": null,
    "title": "Jurulisk",
    "traits": [
      "Ultraterrestrial",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 3,
    "points": 5,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You cannot defeat this card unless you have exactly 8 Total Attack Value.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "ultraterrestrial"
  },
  {
    "id": "monster-lord-of-death",
    "type": "monster",
    "subtype": null,
    "title": "Lord of Death",
    "traits": [
      "Undead",
      "Doom",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 1,
    "xp": 3,
    "points": 7,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 2 diseases.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadDoom"
  },
  {
    "id": "monster-kingdom",
    "type": "monster",
    "subtype": null,
    "title": "Kingdom",
    "traits": [
      "Undead",
      "Doom",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadDoom"
  },
  {
    "id": "monster-famine",
    "type": "monster",
    "subtype": null,
    "title": "Famine",
    "traits": [
      "Undead",
      "Doom",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadDoom"
  },
  {
    "id": "monster-harbinger",
    "type": "monster",
    "subtype": null,
    "title": "Harbinger",
    "traits": [
      "Undead",
      "Doom",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 3,
    "level": 1,
    "xp": 1,
    "points": 1,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 spell.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadDoom"
  },
  {
    "id": "monster-suffering",
    "type": "monster",
    "subtype": null,
    "title": "Suffering",
    "traits": [
      "Undead",
      "Doom",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each hero suffers Strength -2.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadDoom"
  },
  {
    "id": "monster-soulstolen",
    "type": "monster",
    "subtype": null,
    "title": "Soulstolen",
    "traits": [
      "Undead",
      "Horde",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 4,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 unequipped hero.",
          "repeatable": false
        }
      ],
      "trophy": [
        {
          "text": "Physical Attack +1 against undead.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadHorde"
  },
  {
    "id": "monster-lich-lord",
    "type": "monster",
    "subtype": null,
    "title": "Lich Lord",
    "traits": [
      "Undead",
      "Lich",
      "Level 1"
    ],
    "goldValue": 3,
    "health": 8,
    "level": 1,
    "xp": 3,
    "points": 8,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each hero suffers Attack -1 and Strength -4.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy each hero with Strength 0.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadLich"
  },
  {
    "id": "monster-grave-knight",
    "type": "monster",
    "subtype": null,
    "title": "Grave Knight",
    "traits": [
      "Undead",
      "Lich",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 4,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadLich"
  },
  {
    "id": "monster-tomb-haunt",
    "type": "monster",
    "subtype": null,
    "title": "Tomb Haunt",
    "traits": [
      "Undead",
      "Lich",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadLich"
  },
  {
    "id": "monster-deathbringer",
    "type": "monster",
    "subtype": null,
    "title": "Deathbringer",
    "traits": [
      "Undead",
      "Lich",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 spell.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadLich"
  },
  {
    "id": "monster-destiny",
    "type": "monster",
    "subtype": null,
    "title": "Destiny",
    "traits": [
      "Undead",
      "Lich",
      "Level 1"
    ],
    "goldValue": 3,
    "health": 7,
    "level": 1,
    "xp": 3,
    "points": 6,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Magic Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 cleric or wizard.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadLich"
  },
  {
    "id": "monster-walking-scourge",
    "type": "monster",
    "subtype": null,
    "title": "Walking Scourge",
    "traits": [
      "Undead",
      "Plague",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 9,
    "level": 2,
    "xp": 3,
    "points": 6,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 2 diseases. Each other player gains 1 disease.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [
        {
          "text": "Each player gains 1 disease.",
          "repeatable": false
        }
      ],
      "raid": []
    },
    "group": "undeadPlague"
  },
  {
    "id": "monster-plaguebearer",
    "type": "monster",
    "subtype": null,
    "title": "Plaguebearer",
    "traits": [
      "Undead",
      "Plague",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 2,
    "xp": 2,
    "points": 3,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "Each player gains 1 disease when another monster is defeated.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadPlague"
  },
  {
    "id": "monster-hungry-dead",
    "type": "monster",
    "subtype": null,
    "title": "Hungry Dead",
    "traits": [
      "Undead",
      "Plague",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 card for each disease present (remember, monster effects do not affect disease cards). Gain 1 disease.)",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadPlague"
  },
  {
    "id": "monster-plague-zombie",
    "type": "monster",
    "subtype": null,
    "title": "Plague Zombie",
    "traits": [
      "Undead",
      "Plague",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 3,
    "level": 2,
    "xp": 1,
    "points": 1,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadPlague"
  },
  {
    "id": "monster-restless-corpse",
    "type": "monster",
    "subtype": null,
    "title": "Restless Corpse",
    "traits": [
      "Undead",
      "Plague",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 2,
    "xp": 1,
    "points": 2,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadPlague"
  },
  {
    "id": "monster-shrouded-cadaver",
    "type": "monster",
    "subtype": null,
    "title": "Shrouded Cadaver",
    "traits": [
      "Undead",
      "Skeleton",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 2 curses. Each other player gains 1 curse.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [
        {
          "text": "You may discard this card to draw a card.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSkeleton"
  },
  {
    "id": "monster-dwarven-ancestor",
    "type": "monster",
    "subtype": null,
    "title": "Dwarven Ancestor",
    "traits": [
      "Undead",
      "Skeleton",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "If there is Darkness, gain 1 curse.",
          "repeatable": false
        },
        {
          "text": "If you defeat this card's Health by 4 or more, each other player gains 1 curse.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSkeleton"
  },
  {
    "id": "monster-necrophidius",
    "type": "monster",
    "subtype": null,
    "title": "Necrophidius",
    "traits": [
      "Undead",
      "Skeleton",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Cannot be fought unless 2 or more heroes are present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "You may destroy this card to level up a Regular or a level 1 hero without paying XP.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSkeleton"
  },
  {
    "id": "monster-ossuous",
    "type": "monster",
    "subtype": null,
    "title": "Ossuous",
    "traits": [
      "Undead",
      "Skeleton",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 2,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Cannot be fought unless a hero of level 1 or higher is present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Magic Attack +1.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSkeleton"
  },
  {
    "id": "monster-warrior-bones",
    "type": "monster",
    "subtype": null,
    "title": "Warrior Bones",
    "traits": [
      "Undead",
      "Skeleton",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 1,
    "xp": 1,
    "points": 1,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Physical Attack +1.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSkeleton"
  },
  {
    "id": "monster-souleater",
    "type": "monster",
    "subtype": null,
    "title": "Souleater",
    "traits": [
      "Undead",
      "Spectral",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 10,
    "level": 3,
    "xp": 3,
    "points": 8,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Physical Attack and Magic Attack unless you discard 3 cards when you select this monster to fight.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpectral"
  },
  {
    "id": "monster-cruel-apparition",
    "type": "monster",
    "subtype": null,
    "title": "Cruel Apparition",
    "traits": [
      "Undead",
      "Spectral",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 3,
    "xp": 1,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Physical Attack and Magic Attack unless you destroy 1 hero when you select this monster to fight.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpectral"
  },
  {
    "id": "monster-will-o-the-wisp",
    "type": "monster",
    "subtype": null,
    "title": "Will-o'-the-Wisp",
    "traits": [
      "Undead",
      "Spectral",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 3,
    "xp": 1,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Physical Attack and Magic Attack unless you destroy 1 food when you select this monster to fight.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpectral"
  },
  {
    "id": "monster-wight",
    "type": "monster",
    "subtype": null,
    "title": "Wight",
    "traits": [
      "Undead",
      "Spectral",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 7,
    "level": 3,
    "xp": 1,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Physical Attack and Magic Attack unless you discard 2 XP when you select this monster to fight.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpectral"
  },
  {
    "id": "monster-devourer",
    "type": "monster",
    "subtype": null,
    "title": "Devourer",
    "traits": [
      "Undead",
      "Spectral",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 9,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Physical Attack and Magic Attack unless you destroy 1 monster when you select this monster to fight.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpectral"
  },
  {
    "id": "monster-haunt",
    "type": "monster",
    "subtype": null,
    "title": "Haunt",
    "traits": [
      "Undead",
      "Spirit",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 4,
    "level": 2,
    "xp": 1,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Ignore 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpirit"
  },
  {
    "id": "monster-ghost",
    "type": "monster",
    "subtype": null,
    "title": "Ghost",
    "traits": [
      "Undead",
      "Spirit",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 2,
    "xp": 1,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Halve Physical Attack (round down) without Magic Attack present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each hero suffers Strength -2.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpirit"
  },
  {
    "id": "monster-wraith",
    "type": "monster",
    "subtype": null,
    "title": "Wraith",
    "traits": [
      "Undead",
      "Spirit",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 Regular.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpirit"
  },
  {
    "id": "monster-revenant",
    "type": "monster",
    "subtype": null,
    "title": "Revenant",
    "traits": [
      "Undead",
      "Spirit",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 5,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack required.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Each hero suffers Strength -4.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy each hero with Strength 0.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpirit"
  },
  {
    "id": "monster-spectre",
    "type": "monster",
    "subtype": null,
    "title": "Spectre",
    "traits": [
      "Undead",
      "Spirit",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 2,
    "xp": 1,
    "points": 3,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy 1 Regular.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadSpirit"
  },
  {
    "id": "monster-scabbark",
    "type": "monster",
    "subtype": null,
    "title": "Scabbark",
    "traits": [
      "Undead",
      "Treefolk",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 13,
    "level": 3,
    "xp": 4,
    "points": 8,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "If the Total Attack Value did not exceed this card's Health by 2 or more, destroy all cards in your hand.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Take another turn.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    },
    "group": "undeadTreefolk"
  },
  {
    "id": "monster-canker-treant",
    "type": "monster",
    "subtype": null,
    "title": "Canker Treant",
    "traits": [
      "Undead",
      "Treefolk",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "If the Total Attack Value did not exceed this card's Health by 6 or more, draw 2 fewer cards at the end of the turn.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadTreefolk"
  },
  {
    "id": "monster-thorned-walker",
    "type": "monster",
    "subtype": null,
    "title": "Thorned Walker",
    "traits": [
      "Undead",
      "Treefolk",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 10,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "If the Total Attack Value did not exceed this card's Health by 2 or more, destroy 2 revealed monsters.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadTreefolk"
  },
  {
    "id": "monster-withered-dryad",
    "type": "monster",
    "subtype": null,
    "title": "Withered Dryad",
    "traits": [
      "Undead",
      "Treefolk",
      "Level 3"
    ],
    "goldValue": 1,
    "health": 6,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to blunt weapons.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadTreefolk"
  },
  {
    "id": "monster-decayed-heartwood",
    "type": "monster",
    "subtype": null,
    "title": "Decayed Heartwood",
    "traits": [
      "Undead",
      "Treefolk",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 11,
    "level": 3,
    "xp": 3,
    "points": 7,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy a hero with 5 or more Strength.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "undeadTreefolk"
  },
  {
    "id": "monster-steel-spider",
    "type": "monster",
    "subtype": null,
    "title": "Steel Spider",
    "traits": [
      "Verminous",
      "Level 1"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 weapon.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "verminous"
  },
  {
    "id": "monster-stratharian-war-moth",
    "type": "monster",
    "subtype": null,
    "title": "Stratharian War Moth",
    "traits": [
      "Verminous",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 4,
    "light": 1,
    "level": 1,
    "xp": 1,
    "points": 2,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "verminous"
  },
  {
    "id": "monster-scutimorph",
    "type": "monster",
    "subtype": null,
    "title": "Scutimorph",
    "traits": [
      "Verminous",
      "Level 1"
    ],
    "goldValue": 3,
    "health": 6,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "verminous"
  },
  {
    "id": "monster-slicer-beetle",
    "type": "monster",
    "subtype": null,
    "title": "Slicer Beetle",
    "traits": [
      "Verminous",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 1,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 item.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "verminous"
  },
  {
    "id": "monster-laak",
    "type": "monster",
    "subtype": null,
    "title": "Laak",
    "traits": [
      "Verminous",
      "Level 1"
    ],
    "goldValue": 2,
    "health": 5,
    "level": 1,
    "xp": 2,
    "points": 3,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "Physical Attack +1.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "verminous"
  },
  {
    "id": "monster-poison-skeleton",
    "type": "monster",
    "subtype": null,
    "title": "Poison Skeleton",
    "traits": [
      "Virulent",
      "Undead",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 6,
    "level": 2,
    "xp": 1,
    "points": 3,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "virulent"
  },
  {
    "id": "monster-zombie-mob",
    "type": "monster",
    "subtype": null,
    "title": "Zombie Mob",
    "traits": [
      "Virulent",
      "Undead",
      "Level 2"
    ],
    "goldValue": 1,
    "health": 7,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 disease.",
          "repeatable": false
        },
        {
          "text": "This card gains Health +1 for each Undead revealed in your hand.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "virulent"
  },
  {
    "id": "monster-filth-queen",
    "type": "monster",
    "subtype": null,
    "title": "Filth Queen",
    "traits": [
      "Virulent",
      "Undead",
      "Level 2"
    ],
    "goldValue": 3,
    "health": 9,
    "level": 2,
    "xp": 2,
    "points": 5,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 2 diseases.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "virulent"
  },
  {
    "id": "monster-bloodbound",
    "type": "monster",
    "subtype": null,
    "title": "Bloodbound",
    "traits": [
      "Virulent",
      "Undead",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 2,
    "points": 4,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Gain 1 Disease.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "virulent"
  },
  {
    "id": "monster-vampiric-minion",
    "type": "monster",
    "subtype": null,
    "title": "Vampiric Minion",
    "traits": [
      "Virulent",
      "Undead",
      "Level 2"
    ],
    "goldValue": 2,
    "health": 8,
    "level": 2,
    "xp": 3,
    "points": 5,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Regulars.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "virulent"
  },
  {
    "id": "monster-cavernmaw",
    "type": "monster",
    "subtype": null,
    "title": "Cavernmaw",
    "traits": [
      "Worm",
      "Vermin",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 10,
    "level": 3,
    "xp": 3,
    "points": 7,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Immune to Physical Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy 1 hero or villager.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "worm"
  },
  {
    "id": "monster-mancatcher-worm",
    "type": "monster",
    "subtype": null,
    "title": "Mancatcher Worm",
    "traits": [
      "Worm",
      "Vermin",
      "Ambusher",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 7,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack required.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "worm"
  },
  {
    "id": "monster-purple-worm",
    "type": "monster",
    "subtype": null,
    "title": "Purple Worm",
    "traits": [
      "Worm",
      "Vermin",
      "Level 3"
    ],
    "goldValue": 3,
    "health": 11,
    "level": 3,
    "xp": 3,
    "points": 6,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 2 cards or destroy 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "Destroy 1 hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "worm"
  },
  {
    "id": "monster-albino-worm",
    "type": "monster",
    "subtype": null,
    "title": "Albino Worm",
    "traits": [
      "Worm",
      "Vermin",
      "Level 3"
    ],
    "goldValue": 2,
    "health": 10,
    "level": 3,
    "xp": 2,
    "points": 4,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Attack +1 for each card with Light present.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "group": "worm"
  },
  {
    "id": "monster-rot-grub",
    "type": "monster",
    "subtype": null,
    "title": "Rot Grub",
    "traits": [
      "Worm",
      "Vermin",
      "Ambusher",
      "Level 3"
    ],
    "goldValue": 1,
    "health": 5,
    "level": 3,
    "xp": 2,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard all but 1 hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": [
        {
          "text": "Choose 1 hero. If that hero's Attack Value is 5 or higher, defeat this card (you gain the XP). Otherwise, destroy that hero.",
          "repeatable": false
        }
      ]
    },
    "group": "worm"
  },
  {
    "id": "bearer-heart-of-doom",
    "type": "bearer",
    "subtype": null,
    "title": "Heart of Doom",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 0,
    "health": 25,
    "xp": 0,
    "points": 15,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Add Magic Attack +6 to each Thunderstone Shard.",
          "repeatable": false
        }
      ],
      "aftermath": [
        {
          "text": "If this card is not defeated, the active player loses.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "When a player enters the dungeon, destroy all monsters present.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-goron-singlmind",
    "type": "bearer",
    "subtype": null,
    "title": "Goron Singlmind",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 3,
    "health": 16,
    "xp": 4,
    "points": 4,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Suffer Health -2 for each class present.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-stramst",
    "type": "bearer",
    "subtype": null,
    "title": "Stramst",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 3,
    "health": 12,
    "xp": 3,
    "points": 4,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Destroy a hero.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "When refilling the hall, Stramst does not move forward to an empty rank until the dungeon is depleted. Instead, refill the empty rank in front of him.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-xobmokt-ichor-king",
    "type": "bearer",
    "subtype": null,
    "title": "Xobmokt, Ichor King",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 4,
    "health": 12,
    "xp": 4,
    "points": 4,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "Whenever a player discards a card before the end of the turn, destroy that card.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-phylethis",
    "type": "bearer",
    "subtype": null,
    "title": "Phylethis",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 2,
    "health": 12,
    "xp": 4,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard cards equal to the highest level of monster in the hall.",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-sarrak",
    "type": "bearer",
    "subtype": null,
    "title": "Sarrak",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 2,
    "health": 8,
    "xp": 4,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Ignore heroes of level 2 and lower.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-wraithlyn-dragon-general",
    "type": "bearer",
    "subtype": null,
    "title": "Wraithlyn, Dragon General",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 2,
    "health": 12,
    "xp": 3,
    "points": 4,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard 1 weapon, 1 spell, and 1 item (do as much of this as you can).",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-the-last-doomknight",
    "type": "bearer",
    "subtype": null,
    "title": "The Last Doomknight",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 3,
    "health": 15,
    "xp": 3,
    "points": 6,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "Suffer Light -1. Each hero suffers Strength -1. Other monsters add Health +1.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-void-apocalypse",
    "type": "bearer",
    "subtype": null,
    "title": "Void Apocalypse",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 3,
    "health": 20,
    "xp": 4,
    "points": 10,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Choose 1 copy of each hero present (by card title). Ignore all other heroes.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy all cards that have more than 1 copy present.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-oblivion-deathkeeper",
    "type": "bearer",
    "subtype": null,
    "title": "Oblivion, Deathkeeper",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 3,
    "health": 10,
    "xp": 4,
    "points": 6,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "Discard 1 random card when you enter the dungeon.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-mowtil-djinni-lich",
    "type": "bearer",
    "subtype": null,
    "title": "Mowtil, Djinni Lich",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 3,
    "health": 8,
    "xp": 4,
    "points": 4,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack required",
          "repeatable": false
        },
        {
          "text": "Add Health +1 for each card present.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "If this card is not defeated, destroy a card of 1 VP or higher.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-orseg",
    "type": "bearer",
    "subtype": null,
    "title": "Orseg",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 3,
    "health": 12,
    "xp": 4,
    "points": 5,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Orseg gains the Battle effects of each other monster in the dungeon hall.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-king-caelan",
    "type": "bearer",
    "subtype": null,
    "title": "King Caelan",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 3,
    "health": 10,
    "xp": 5,
    "points": 5,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You cannot select this monster to fight if you have used a Dungeon ability on a hero or villager.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-convergence-master",
    "type": "bearer",
    "subtype": null,
    "title": "Convergence Master",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 2,
    "health": 7,
    "xp": 4,
    "points": 4,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Add Health +1 for each card present (in your hand).",
          "repeatable": false
        },
        {
          "text": "This card gains the Battle ability on each card present (in your hand).",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "bearer-belac",
    "type": "bearer",
    "subtype": null,
    "title": "Belac",
    "traits": [
      "Thunderstone Bearer",
      "Guardian"
    ],
    "goldValue": 3,
    "health": 8,
    "xp": 3,
    "points": 4,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [
        {
          "text": "Discard the hero with the highest Attack Value. Belac gains Health equal to that hero's Attack Value (including weapons).",
          "repeatable": false
        }
      ],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [
        {
          "text": "Resolve all other monsters' Battle effects twice.",
          "repeatable": false
        }
      ],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-ambrosia",
    "type": "village",
    "subtype": null,
    "title": "Ambrosia",
    "traits": [
      "Item",
      "Food",
      "Magic"
    ],
    "goldValue": 2,
    "cost": 6,
    "xp": 0,
    "points": 2,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 and Strength +2 to each hero. Whenever a Battle or Aftermath effect destroys a hero, discard that hero instead.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-animal-talisman",
    "type": "village",
    "subtype": null,
    "title": "Animal Talisman",
    "traits": [
      "Item",
      "Light",
      "Magic"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add one of the following to 1 hero: Magic Attack +2, or Light +2, or Strength +4.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-augmentation-amulet",
    "type": "village",
    "subtype": null,
    "title": "Augmentation Amulet",
    "traits": [
      "Item",
      "Light",
      "Magic"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 to each human hero present. Add Light +1 to each elf hero present. Add Strength +2 to each dwarf hero present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-backpack",
    "type": "village",
    "subtype": null,
    "title": "Backpack",
    "traits": [
      "Item"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Reveal the top 2 cards of your deck. Place 1 revealed item or weapon in your hand. Discard the rest.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Reveal the top 2 cards of your deck. Place 1 revealed item or weapon in your hand. Discard the rest.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-bandias-wisdom",
    "type": "village",
    "subtype": null,
    "title": "Bandia's Wisdom",
    "traits": [
      "Spell",
      "Support"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Give each hero Strength +1. Gain 3 XP. Discard 2 XP at the end of your turn.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-banish",
    "type": "village",
    "subtype": null,
    "title": "Banish",
    "traits": [
      "Spell",
      "Auxiliary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Place 1 monster from the hall on the bottom of the dungeon deck and refill the hall, or rearrange the hall. Destroy 1 card from your hand (this card can destroy itself). Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-bardiche",
    "type": "village",
    "subtype": null,
    "title": "Bardiche",
    "traits": [
      "Weapon",
      "Polearm"
    ],
    "goldValue": 2,
    "weight": 3,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +1 while attacking a monster in Rank 1.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-battle-scarred-soldier",
    "type": "village",
    "subtype": null,
    "title": "Battle-scarred Soldier",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Draw 1 card. If it is a hero it gains Physical Attack +2.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-bio-energy-cutter",
    "type": "village",
    "subtype": null,
    "title": "Bio-energy Cutter",
    "traits": [
      "Weapon",
      "Edged",
      "Magic"
    ],
    "goldValue": 1,
    "weight": 2,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack equal to the XP of the monster selected to fight.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Each other player discards 1 card.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-bio-salvager",
    "type": "village",
    "subtype": null,
    "title": "Bio-salvager",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 1 card. If it is a monster, draw 1 additional card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Draw 1 card. If it is a monster, draw 1 additional card.",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +1 if a monster is present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-blessed-hammer",
    "type": "village",
    "subtype": null,
    "title": "Blessed Hammer",
    "traits": [
      "Weapon",
      "Blunt"
    ],
    "goldValue": 2,
    "weight": 4,
    "light": 0,
    "cost": 8,
    "xp": 0,
    "points": 1,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Place the monster in rank 1 on the bottom of the dungeon deck. Refill the hall.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-blood-debt",
    "type": "village",
    "subtype": null,
    "title": "Blood Debt",
    "traits": [
      "Item"
    ],
    "goldValue": 5,
    "light": 0,
    "cost": 1,
    "xp": 0,
    "points": -3,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "This card can only be destroyed by itself.",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "If you have 10 gold, destroy this card and end your turn.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-bloodhound",
    "type": "village",
    "subtype": null,
    "title": "Bloodhound",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Physical Attack +2 if at least 1 hero is present.",
          "repeatable": false
        },
        {
          "text": "Physical Attack +1 if at least 1 other Bloodhound is present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-bolt-of-purity",
    "type": "village",
    "subtype": null,
    "title": "Bolt of Purity",
    "traits": [
      "Spell",
      "Attack"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Magic Attack +2. Destroy 1 disease.",
          "repeatable": false
        },
        {
          "text": "Magic Attack +1 against monsters that give diseases.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-border-guard",
    "type": "village",
    "subtype": null,
    "title": "Border Guard",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 1 card. Discard 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Draw 1 card. Discard 1 card.",
          "repeatable": false
        },
        {
          "text": "Physical Attack +1.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "Destroy this card to prevent 1 hero from being destroyed by a Battle or Aftermath effect.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-bounty-hunter",
    "type": "village",
    "subtype": null,
    "title": "Bounty Hunter",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Buy 1 village card.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-castellan",
    "type": "village",
    "subtype": null,
    "title": "Castellan",
    "traits": [
      "Villager"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 7,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 3 cards.",
          "repeatable": false
        },
        {
          "text": "Destroy this card to draw 3 cards, and you may buy 1 additional card this turn.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-chalice-mace",
    "type": "village",
    "subtype": null,
    "title": "Chalice Mace",
    "traits": [
      "Weapon",
      "Blunt",
      "Light"
    ],
    "goldValue": 2,
    "weight": 6,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 1,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Clerics require 3 less Strength to equip. Add Light +1 while equipped to a cleric.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-champion-sword",
    "type": "village",
    "subtype": null,
    "title": "Champion Sword",
    "traits": [
      "Weapon",
      "Edged"
    ],
    "goldValue": 2,
    "weight": 6,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-charm-of-venery",
    "type": "village",
    "subtype": null,
    "title": "Charm of Venery",
    "traits": [
      "Item",
      "Magic",
      "Light"
    ],
    "goldValue": 0,
    "light": 2,
    "cost": 2,
    "xp": 0,
    "points": 2,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "When this card is present, you may not visit the village.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-chemical-injector",
    "type": "village",
    "subtype": null,
    "title": "Chemical Injector",
    "traits": [
      "Item",
      "Light"
    ],
    "goldValue": 2,
    "light": 1,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 to each hero.",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +2 to one hero against Doomladen and Doomknights.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-chieftains-drum",
    "type": "village",
    "subtype": null,
    "title": "Chieftain's Drum",
    "traits": [
      "Item",
      "Magic"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Choose hero, village, or monster. Reveal the top card of your deck. If you named the card's type correctly, draw 2 cards. If not, return it.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Choose hero, village, or monster. Reveal the top card of your deck. If you named the card's type correctly, draw 2 cards. If not, return it.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-circle-of-protection",
    "type": "village",
    "subtype": null,
    "title": "Circle of Protection",
    "traits": [
      "Spell",
      "Auxiliary"
    ],
    "goldValue": 0,
    "light": 1,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "On your turn, place this card in front of you. It remains in play. Cancel the next Raid, Breach, or Aftermath effect that takes place on your turn and destroy this card.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-creeping-death",
    "type": "village",
    "subtype": null,
    "title": "Creeping Death",
    "traits": [
      "Spell",
      "Attack"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 11,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Each other player who has not gained a disease this turn gains 1 disease. Each monster in the hall suffers Health -2. If this reduces a monster's Health to 0, place that monster into your discard pile and refill the hall. (This does not count as defeating a monster. Do not collect XP.)",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-curative-draught",
    "type": "village",
    "subtype": null,
    "title": "Curative Draught",
    "traits": [
      "Item",
      "Food"
    ],
    "goldValue": 3,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy 1 disease.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 disease, or destroy this card to add Physical Attack +1 to one hero.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-cursed-dagger",
    "type": "village",
    "subtype": null,
    "title": "Cursed Dagger",
    "traits": [
      "Weapon",
      "Edged"
    ],
    "goldValue": 0,
    "weight": 2,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Gain 1 curse to add Physical Attack +1.",
          "repeatable": false
        },
        {
          "text": "Gain 2 curses to add Physical Attack +2.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-cursed-mace",
    "type": "village",
    "subtype": null,
    "title": "Cursed Mace",
    "traits": [
      "Weapon",
      "Blunt"
    ],
    "goldValue": 0,
    "weight": 5,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +6",
          "repeatable": false
        },
        {
          "text": "Gain 1 disease when equipped.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-dancing-sword",
    "type": "village",
    "subtype": null,
    "title": "Dancing Sword",
    "traits": [
      "Weapon",
      "Edged",
      "Magic",
      "Light"
    ],
    "goldValue": 2,
    "weight": 5,
    "light": 1,
    "cost": 8,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Even if not equipped, Magic Attack +2 (and still provides light).",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-dart-thrower",
    "type": "village",
    "subtype": null,
    "title": "Dart Thrower",
    "traits": [
      "Weapon",
      "Bow",
      "Light"
    ],
    "goldValue": 3,
    "weight": 5,
    "light": 1,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4 against rank 2 or higher.",
          "repeatable": false
        },
        {
          "text": "Rangers of any Strength may equip this weapon. While equipped to a ranger, this weapon's Attack can apply to rank 1.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-debased-wizard",
    "type": "village",
    "subtype": null,
    "title": "Debased Wizard",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 2,
    "light": 1,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Gain 1 curse. Use an ability on a card present that you have already used this turn.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Gain 1 curse. Use an ability on a card present that you have already used this turn.",
          "repeatable": false
        },
        {
          "text": "Select 1 Battle effect on a monster. Ignore that Battle effect. Gain 1 curse.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-demon-vision",
    "type": "village",
    "subtype": null,
    "title": "Demon Vision",
    "traits": [
      "Spell",
      "Auxiliary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 7,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Choose a number from 1-5. Reveal that many cards from your deck. Destroy all revealed cards with a VP value less than the number you chose. Add 1 remaining card to your hand. Discard the rest.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Choose a number from 1-5. Reveal that many cards from your deck. Destroy all revealed cards with a VP value less than the number you chose. Add 1 remaining card to your hand. Discard the rest.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-disruption-blade",
    "type": "village",
    "subtype": null,
    "title": "Disruption Blade",
    "traits": [
      "Weapon",
      "Edged"
    ],
    "goldValue": 2,
    "weight": 4,
    "light": 0,
    "cost": 6,
    "xp": 0,
    "points": 1,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-doomgate-squire",
    "type": "village",
    "subtype": null,
    "title": "Doomgate Squire",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        },
        {
          "text": "You may buy 1 additional card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        },
        {
          "text": "Discard 1 XP to add Physical Attack +1 to one hero.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-dredging-net",
    "type": "village",
    "subtype": null,
    "title": "Dredging Net",
    "traits": [
      "Item"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 3 cards from the bottom of your deck. Discard 1, destroy 1, and place 1 in your hand.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-drill-sergeant",
    "type": "village",
    "subtype": null,
    "title": "Drill Sergeant",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 1 card for each 2 XP you possess (round down), to a maximum of 5 cards.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 Regular to draw 2 cards and gain 1 XP.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-dwarven-ale",
    "type": "village",
    "subtype": null,
    "title": "Dwarven Ale",
    "traits": [
      "Item",
      "Food"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 and Strength +1 to each hero.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [
        {
          "text": "If a dwarf hero is present, 1 dwarf hero adds Physical Attack +4. Destroy this card.",
          "repeatable": false
        }
      ],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-dwarven-bear-hammer",
    "type": "village",
    "subtype": null,
    "title": "Dwarven Bear Hammer",
    "traits": [
      "Weapon",
      "Blunt"
    ],
    "goldValue": 2,
    "weight": 6,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "Dwarf heroes of any Strength may equip this weapon.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-elven-waybread",
    "type": "village",
    "subtype": null,
    "title": "Elven Waybread",
    "traits": [
      "Item",
      "Food"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 1,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy this card. At the end of this turn, place 1 hero on top of your deck.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Each of your heroes adds Strength +2.",
          "repeatable": false
        },
        {
          "text": "Destroy this card. At the end of this turn, place 1 hero on top of your deck.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-entrail-reader",
    "type": "village",
    "subtype": null,
    "title": "Entrail Reader",
    "traits": [
      "Villager"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Reveal the top card of your deck. Put it back, discard it or destroy it. If you destroyed it, you may use this ability a second time.",
          "repeatable": false
        },
        {
          "text": "Destroy this card to draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-falcon-arbalest",
    "type": "village",
    "subtype": null,
    "title": "Falcon Arbalest",
    "traits": [
      "Weapon",
      "Bow"
    ],
    "goldValue": 2,
    "weight": 3,
    "light": 0,
    "cost": 7,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Reduce the equipped hero's Attack to 0.",
          "repeatable": false
        },
        {
          "text": "Physical Attack +5 against rank 2 or higher.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-fearmaker",
    "type": "village",
    "subtype": null,
    "title": "Fearmaker",
    "traits": [
      "Spell",
      "Auxiliary",
      "Light"
    ],
    "goldValue": 0,
    "light": 3,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [
        {
          "text": "If you did not defeat a monster, detroy this card. At the end of this turn, take another turn.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-feast",
    "type": "village",
    "subtype": null,
    "title": "Feast",
    "traits": [
      "Item",
      "Food"
    ],
    "goldValue": 3,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 and Strength +3 to each hero.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-filigree-amulet",
    "type": "village",
    "subtype": null,
    "title": "Filigree Amulet",
    "traits": [
      "Item",
      "Magic",
      "Light"
    ],
    "goldValue": 3,
    "light": 2,
    "cost": 2,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "You may buy a second card when you purchase this card.",
          "repeatable": false
        },
        {
          "text": "Destroy this card instead of discarding it at the end of the turn.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-fireball",
    "type": "village",
    "subtype": null,
    "title": "Fireball",
    "traits": [
      "Spell",
      "Attack",
      "Light"
    ],
    "goldValue": 0,
    "light": 1,
    "cost": 9,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-flaming-sword",
    "type": "village",
    "subtype": null,
    "title": "Flaming Sword",
    "traits": [
      "Weapon",
      "Edged",
      "Magic",
      "Light"
    ],
    "goldValue": 2,
    "weight": 5,
    "light": 1,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-force-blast",
    "type": "village",
    "subtype": null,
    "title": "Force Blast",
    "traits": [
      "Spell",
      "Attack",
      "Light"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 7,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        },
        {
          "text": "Light +1 for each level of one wizard present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-frost-giant-axe",
    "type": "village",
    "subtype": null,
    "title": "Frost Giant Axe",
    "traits": [
      "Weapon",
      "Edged",
      "Magic"
    ],
    "goldValue": 3,
    "weight": 6,
    "light": 0,
    "cost": 8,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "If no hero present has Strength 6 or higher, draw 1 card. If it is a hero, add Strength +3 to that hero. (You can use this ability while this card is not equipped.)",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-greatsword",
    "type": "village",
    "subtype": null,
    "title": "Greatsword",
    "traits": [
      "Weapon",
      "Edged"
    ],
    "goldValue": 2,
    "weight": 7,
    "light": 0,
    "cost": 8,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Discard this card and its equipped hero to place a monster with Health less than or equal to the equipped hero's Attack Value on your discard pile (do not collect XP).",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-guardian-blade",
    "type": "village",
    "subtype": null,
    "title": "Guardian Blade",
    "traits": [
      "Weapon",
      "Edged"
    ],
    "goldValue": 2,
    "weight": 5,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        },
        {
          "text": "If the equipped hero would be destroyed, discard that hero instead.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-guide",
    "type": "village",
    "subtype": null,
    "title": "Guide",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 2,
    "light": 2,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "You may buy 1 additional card.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-hedge-witch",
    "type": "village",
    "subtype": null,
    "title": "Hedge Witch",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Discard 2 XP to draw 1 card.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease.",
          "repeatable": true
        }
      ],
      "dungeon": [
        {
          "text": "Discard 2 XP to draw 1 card.",
          "repeatable": false
        },
        {
          "text": "Destroy 1 disease.",
          "repeatable": true
        },
        {
          "text": "Discard 2 XP to add Magic Attack +1.",
          "repeatable": true
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-historian",
    "type": "village",
    "subtype": null,
    "title": "Historian",
    "traits": [
      "Villager"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "If a hero is present, gain 1 XP.",
          "repeatable": false
        },
        {
          "text": "Destroy this card. Draw 1 additional card after you refill your hand at the end of the turn.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-hysterical-villager",
    "type": "village",
    "subtype": null,
    "title": "Hysterical Villager",
    "traits": [
      "Villager"
    ],
    "goldValue": 1,
    "light": 0,
    "cost": 2,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy the top card of 1 hero stack.",
          "repeatable": false
        },
        {
          "text": "Destroy this card to gain 3 gold.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-icon-of-inversion",
    "type": "village",
    "subtype": null,
    "title": "Icon of Inversion",
    "traits": [
      "Item"
    ],
    "goldValue": 1,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "When you buy this card, you may buy one additional card.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Battle effects become Aftermath effects.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-innkeeper",
    "type": "village",
    "subtype": null,
    "title": "Innkeeper",
    "traits": [
      "Villager"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy a villager or hero. You may buy an additional card this turn.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-insight",
    "type": "village",
    "subtype": null,
    "title": "Insight",
    "traits": [
      "Spell",
      "Auxiliary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Rearrange the dungeon hall (you may not move Guardians). Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-jondul-bow",
    "type": "village",
    "subtype": null,
    "title": "Jondul Bow",
    "traits": [
      "Weapon",
      "Bow"
    ],
    "goldValue": 2,
    "weight": 5,
    "light": 0,
    "cost": 7,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4 against rank 2 or higher",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Switch the positions of 2 adjacent monsters in the hall.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-king-caelans-writ",
    "type": "village",
    "subtype": null,
    "title": "King Caelan's Writ",
    "traits": [
      "Item"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy this card to place the top card of any hero stack on top of your deck. End your turn.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-labrys",
    "type": "village",
    "subtype": null,
    "title": "Labrys",
    "traits": [
      "Weapon",
      "Edged"
    ],
    "goldValue": 1,
    "weight": 6,
    "light": 0,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-lightstone-gem",
    "type": "village",
    "subtype": null,
    "title": "Lightstone Gem",
    "traits": [
      "Item",
      "Magic",
      "Light"
    ],
    "goldValue": 3,
    "light": 3,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-liveoak-bow",
    "type": "village",
    "subtype": null,
    "title": "Liveoak Bow",
    "traits": [
      "Weapon",
      "Bow"
    ],
    "goldValue": 3,
    "weight": 4,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +5",
          "repeatable": false
        },
        {
          "text": "Subtract the selected monster's rank from this card's Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-liveoak-staff",
    "type": "village",
    "subtype": null,
    "title": "Liveoak Staff",
    "traits": [
      "Weapon",
      "Blunt"
    ],
    "goldValue": 2,
    "weight": 1,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +6",
          "repeatable": false
        },
        {
          "text": "Subtract the Strength of the equipped hero from this card's Physical Attack.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-longsword",
    "type": "village",
    "subtype": null,
    "title": "Longsword",
    "traits": [
      "Weapon",
      "Edged"
    ],
    "goldValue": 3,
    "weight": 5,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-mass-teleport",
    "type": "village",
    "subtype": null,
    "title": "Mass Teleport",
    "traits": [
      "Spell",
      "Support"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 3 cards. You cannot use any more Dungeon abilities this turn (you may still equip weapons).",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-maul",
    "type": "village",
    "subtype": null,
    "title": "Maul",
    "traits": [
      "Weapon",
      "Blunt"
    ],
    "goldValue": 1,
    "weight": 3,
    "light": 0,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack -2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack equal to the equipped hero's Strength.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-mental-scrambler",
    "type": "village",
    "subtype": null,
    "title": "Mental Scrambler",
    "traits": [
      "Spell",
      "Attack"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 2,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        },
        {
          "text": "Discard 4 cards from your deck. Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-mind-control",
    "type": "village",
    "subtype": null,
    "title": "Mind Control",
    "traits": [
      "Spell",
      "Auxiliary"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 7,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy this card. Place 1 monster from the hall in front of a player. Refill the hall. On that player's turn, that player must enter the dungeon and attack that monster if able (its rank and Darkness are 0). If the monster is not defeated, place it on the bottom of the dungeon deck.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-moonstone",
    "type": "village",
    "subtype": null,
    "title": "Moonstone",
    "traits": [
      "Item",
      "Light"
    ],
    "goldValue": 2,
    "light": 2,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-nevajin",
    "type": "village",
    "subtype": null,
    "title": "Nevajin",
    "traits": [
      "Villager"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy 1 hero. Gain gold equal to its Strength.",
          "repeatable": false
        },
        {
          "text": "Destroy this card to draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-novice-mage",
    "type": "village",
    "subtype": null,
    "title": "Novice Mage",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 0,
    "light": 1,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Magic Attack +1.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-opportunist",
    "type": "village",
    "subtype": null,
    "title": "Opportunist",
    "traits": [
      "Villager"
    ],
    "goldValue": 1,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy 1 Regular, Torch, or Longspear to gain 2 gold. Discard this card.",
          "repeatable": false
        },
        {
          "text": "Destroy this card to gain 1 XP.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-owl-eyes",
    "type": "village",
    "subtype": null,
    "title": "Owl Eyes",
    "traits": [
      "Spell",
      "Support"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Ignore Darkness penalty. Attack -2 for each point of Light.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-paired-swords",
    "type": "village",
    "subtype": null,
    "title": "Paired Swords",
    "traits": [
      "Weapon",
      "Edged"
    ],
    "goldValue": 2,
    "weight": 5,
    "light": 0,
    "cost": 7,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +4",
          "repeatable": false
        },
        {
          "text": "When you buy this card, you may place another copy of it from the village into your discard pile.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-partisan",
    "type": "village",
    "subtype": null,
    "title": "Partisan",
    "traits": [
      "Weapon",
      "Polearm"
    ],
    "goldValue": 2,
    "weight": 3,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 for each other equipped polearm present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-phase-disruptor",
    "type": "village",
    "subtype": null,
    "title": "Phase Disruptor",
    "traits": [
      "Item"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy this card and 2 other cards. Draw 1 card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy this card and 2 other cards. Draw 1 card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-pike",
    "type": "village",
    "subtype": null,
    "title": "Pike",
    "traits": [
      "Weapon",
      "Polearm"
    ],
    "goldValue": 2,
    "weight": 3,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "This hero is not affected by Battle effects.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-polearm",
    "type": "village",
    "subtype": null,
    "title": "Polearm",
    "traits": [
      "Weapon",
      "Edged",
      "Polearm"
    ],
    "goldValue": 3,
    "weight": 2,
    "light": 0,
    "cost": 7,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +4 while equipped to a hero with Strength 8 or higher.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-punch-dagger",
    "type": "village",
    "subtype": null,
    "title": "Punch Dagger",
    "traits": [
      "Weapon",
      "Edged"
    ],
    "goldValue": 2,
    "weight": 2,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        },
        {
          "text": "Heroes may equip 2 of this card.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-radiant-orb",
    "type": "village",
    "subtype": null,
    "title": "Radiant Orb",
    "traits": [
      "Item",
      "Magic",
      "Light"
    ],
    "goldValue": 1,
    "light": 2,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-rage-of-the-disowned",
    "type": "village",
    "subtype": null,
    "title": "Rage of the Disowned",
    "traits": [
      "Spell",
      "Support"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 9,
    "xp": 0,
    "points": -2,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "This card cannot be discarded or destroyed.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "One hero adds Physical Attack +5 and cannot be discarded or destroyed by Dungeon abilities or Battle effects.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy that hero.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-rangers-wilderness-map",
    "type": "village",
    "subtype": null,
    "title": "Ranger's Wilderness Map",
    "traits": [
      "Item"
    ],
    "goldValue": 3,
    "light": 0,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Reveal the bottom card of the dungeon deck. If it is a non-guardian monster, you have switch it with a monster in rank 3 or deeper. Draw a card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-ray-emitter",
    "type": "village",
    "subtype": null,
    "title": "Ray Emitter",
    "traits": [
      "Spell",
      "Support",
      "Light"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add List +1 if a cleric is present.",
          "repeatable": false
        },
        {
          "text": "Add Strength +2 to each hero.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Gain XP equal to the rank of he monster defeated.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-reckless-conjure",
    "type": "village",
    "subtype": null,
    "title": "Reckless Conjure",
    "traits": [
      "Spell",
      "Support"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Draw 2 cards. Discard 4 cards.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-reclusive-mystic",
    "type": "village",
    "subtype": null,
    "title": "Reclusive Mystic",
    "traits": [
      "Villager"
    ],
    "goldValue": 1,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "If you have 0 or 1 XP, gain 1 XP.",
          "repeatable": false
        },
        {
          "text": "Destroy this card to level up a hero in your discard pile (pay all costs).",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-retaliation-nodule",
    "type": "village",
    "subtype": null,
    "title": "Retaliation Nodule",
    "traits": [
      "Spell",
      "Attack"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        },
        {
          "text": "Add Magic Attack +1 for each hero class present.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-ritual-of-cleansing",
    "type": "village",
    "subtype": null,
    "title": "Ritual of Cleansing",
    "traits": [
      "Spell",
      "Auxiliary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Discard the top 5 cards of any player's deck. That player destroys 2 of those cards. If this targeted a player other than you, destroy this card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Discard the top 5 cards of any player's deck. That player destroys 2 of those cards. If this targeted a player other than you, destroy this card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-rolling-sparks",
    "type": "village",
    "subtype": null,
    "title": "Rolling Sparks",
    "traits": [
      "Spell",
      "Attack",
      "Light"
    ],
    "goldValue": 0,
    "light": 2,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-royal-summons",
    "type": "village",
    "subtype": null,
    "title": "Royal Summons",
    "traits": [
      "Spell",
      "Auxiliary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 8,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add 3 Regulars from the village to your hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Destroy 3 Regulars.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-runed-hammer",
    "type": "village",
    "subtype": null,
    "title": "Runed Hammer",
    "traits": [
      "Weapon",
      "Blunt"
    ],
    "goldValue": 2,
    "weight": 4,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-sage",
    "type": "village",
    "subtype": null,
    "title": "Sage",
    "traits": [
      "Villager"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy 1 card (this card can destroy itself). If the card you destroy is not a hero, gain 1 XP.",
          "repeatable": false
        },
        {
          "text": "Destroy the card. Gain 1 gold for each hero present.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-seedbomb",
    "type": "village",
    "subtype": null,
    "title": "Seedbomb",
    "traits": [
      "Weapon",
      "Magic"
    ],
    "goldValue": 2,
    "weight": 3,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "When you level up a hero, destroy this card to put the lower-level hero in your discard pile instead of destroying it.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-shield-bearer",
    "type": "village",
    "subtype": null,
    "title": "Shield Bearer",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 2,
    "light": 1,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Physical Attack +1.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "When one or more heroes would be destroyed by a monster's effect, destroy this card instead.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-shock-nodule",
    "type": "village",
    "subtype": null,
    "title": "Shock Nodule",
    "traits": [
      "Weapon",
      "Blunt"
    ],
    "goldValue": 2,
    "weight": 5,
    "light": 0,
    "cost": 7,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Draw until you have 8 cards.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-short-bow",
    "type": "village",
    "subtype": null,
    "title": "Short Bow",
    "traits": [
      "Weapon",
      "Bow"
    ],
    "goldValue": 3,
    "weight": 4,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +3 against rank 2 or higher.",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +2 while equipped to a ranger.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-smuggler",
    "type": "village",
    "subtype": null,
    "title": "Smuggler",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 1,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy 1 card with a gold value of 1 or higher to gain 4 gold.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [
        {
          "text": "Destroy this card after a player loses a combat. Buy 1 card.",
          "repeatable": false
        }
      ],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-snakehead-flail",
    "type": "village",
    "subtype": null,
    "title": "Snakehead Flail",
    "traits": [
      "Weapon",
      "Blunt",
      "Magic"
    ],
    "goldValue": 1,
    "weight": 3,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        },
        {
          "text": "Additional Magic Attack equal to the level of the equipped hero.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-soulfire",
    "type": "village",
    "subtype": null,
    "title": "Soulfire",
    "traits": [
      "Spell",
      "Attack",
      "Light"
    ],
    "goldValue": 0,
    "light": 1,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        },
        {
          "text": "Discard up to 5 XP. Add Magic Attack +1 for each XP discarded.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-spear",
    "type": "village",
    "subtype": null,
    "title": "Spear",
    "traits": [
      "Weapon",
      "Polearm",
      "Edged"
    ],
    "goldValue": 2,
    "weight": 4,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +2",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +3 while this weapon is equipped.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [
        {
          "text": "Destroy this card if you used its Dungeon ability.",
          "repeatable": false
        }
      ],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-stablehand",
    "type": "village",
    "subtype": null,
    "title": "Stablehand",
    "traits": [
      "Villager"
    ],
    "goldValue": 1,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy 1 card in your discard pile.",
          "repeatable": false
        },
        {
          "text": "Destroy this card to place your deck into your discard pile.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy 1 card in your discard pile.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-summon-aid",
    "type": "village",
    "subtype": null,
    "title": "Summon Aid",
    "traits": [
      "Spell",
      "Support"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "Start",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Reveal the top 2 cards of your deck. Place any revealed heroes into your hand. Discard the rest of the revealed cards.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-summon-storm",
    "type": "village",
    "subtype": null,
    "title": "Summon Storm",
    "traits": [
      "Spell",
      "Attack",
      "Light"
    ],
    "goldValue": 0,
    "light": 1,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Put this card on top of your deck.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Magic Attack +2.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-swamp-provisions",
    "type": "village",
    "subtype": null,
    "title": "Swamp Provisions",
    "traits": [
      "Item",
      "Food"
    ],
    "goldValue": 1,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add Strength +3 to 1 hero.",
          "repeatable": false
        },
        {
          "text": "Destroy this card. Add Physical Attack +3 to 1 hero. Each player gains 1 disease.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-taproot-blade",
    "type": "village",
    "subtype": null,
    "title": "Taproot Blade",
    "traits": [
      "Weapon",
      "Edged",
      "Light"
    ],
    "goldValue": 2,
    "weight": 4,
    "light": 0,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Magic Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy 1 card to add Magic Attack +2 and Light +1.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-thorn-caltrops",
    "type": "village",
    "subtype": null,
    "title": "Thorn Caltrops",
    "traits": [
      "Weapon"
    ],
    "goldValue": 0,
    "weight": 1,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        },
        {
          "text": "Cancel Raid effects.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy this card to cancel 1 Battle effect.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-time-bend",
    "type": "village",
    "subtype": null,
    "title": "Time Bend",
    "traits": [
      "Spell",
      "Auxiliary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 1 card. Set aside a card that you have not used. Add that card to your hand after you refill your hand at the end of the turn.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Draw 1 card. Set aside a card that you have not used. Add that card to your hand after you refill your hand at the end of the turn.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-tincture-of-victims",
    "type": "village",
    "subtype": null,
    "title": "Tincture of Victims",
    "traits": [
      "Item",
      "Food",
      "Magic"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "RoC",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Convert all Magic Attack to Physical Attack, or vice versa. Discard 1 XP.",
          "repeatable": false
        },
        {
          "text": "Add Physical Attack +2 and Strength +3 to one hero. Destroy this card or gain 1 curse.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-toryn-gauntlet",
    "type": "village",
    "subtype": null,
    "title": "Toryn Gauntlet",
    "traits": [
      "Item",
      "Magic"
    ],
    "goldValue": 3,
    "light": 0,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "ItA",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add Magic Attack +2 and Strength +2 to one hero. You may consider that hero to be equipped with a magic weapon.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-town-guard",
    "type": "village",
    "subtype": null,
    "title": "Town Guard",
    "traits": [
      "Villager"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Draw 2 cards.",
          "repeatable": false
        },
        {
          "text": "Destroy this card to draw 3 cards.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-trader",
    "type": "village",
    "subtype": null,
    "title": "Trader",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "WC",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy 1 card to place 1 village card that costs up to 2 gold more into your discard pile. (This card may destroy itself.)",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Draw 1 card. If it is a monster, draw another card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-unstable-crystals",
    "type": "village",
    "subtype": null,
    "title": "Unstable Crystals",
    "traits": [
      "Item",
      "Magic",
      "Light"
    ],
    "goldValue": 2,
    "light": 1,
    "cost": 6,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "If 3 or more copies of this card are present, destroy all copies of this card and 1 random card. End your turn.",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Add Magic Attack +3 to one hero. Place a copy of this card from the village into your discard pile.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-veteran-trainer",
    "type": "village",
    "subtype": null,
    "title": "Veteran Trainer",
    "traits": [
      "Villager"
    ],
    "goldValue": 2,
    "light": 0,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Gain XP equal to the number of monsters you revealed.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Destroy the card to level up one hero without paying XP.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-village-headman",
    "type": "village",
    "subtype": null,
    "title": "Village Headman",
    "traits": [
      "Villager",
      "Mercenary"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "Add Physical Attack +1 for each villager present (including this one).",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-village-jack",
    "type": "village",
    "subtype": null,
    "title": "Village Jack",
    "traits": [
      "Villager"
    ],
    "goldValue": 0,
    "light": 0,
    "cost": 4,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Destroy 1 card to gain 2 gold or 1 XP. (This card may destroy itself.)",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "village-warder",
    "type": "village",
    "subtype": null,
    "title": "Warder",
    "traits": [
      "Item",
      "Light"
    ],
    "goldValue": 2,
    "light": 2,
    "cost": 5,
    "xp": 0,
    "points": 0,
    "set": "Numenera",
    "abilityText": {
      "alwaysActive": [],
      "village": [
        {
          "text": "Look at the top card of any deck. If it is not the dungeon deck, you may put the card on the bottom of the deck.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Look at the top card of any deck. If it is not the dungeon deck, you may put the card on the bottom of the deck.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "basic-regular",
    "type": "basic",
    "subtype": null,
    "title": "Regular",
    "traits": [
      "Level 0",
      "Basic"
    ],
    "goldValue": 0,
    "strength": 3,
    "cost": 0,
    "level": 0,
    "xp": 2,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "If equipped with a polearm, draw a card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "basic-longspear",
    "type": "basic",
    "subtype": "weapon",
    "title": "Longspear",
    "traits": [
      "Weapon",
      "Polearm",
      "Basic"
    ],
    "goldValue": 2,
    "weight": 3,
    "light": 0,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Physical Attack +1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "basic-torch",
    "type": "basic",
    "subtype": "item",
    "title": "Torch",
    "traits": [
      "Item",
      "Light",
      "Basic"
    ],
    "goldValue": 2,
    "light": 1,
    "cost": 3,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "basic-thunderstone-shard",
    "type": "basic",
    "subtype": "item",
    "title": "Thunderstone Shard",
    "traits": [
      "Item",
      "Thunderstone"
    ],
    "goldValue": 1,
    "cost": 0,
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [
        {
          "text": "One hero gains Strength +2.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [
        {
          "text": "Gain 1 XP.",
          "repeatable": false
        }
      ],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "curse-decay",
    "type": "curse",
    "subtype": null,
    "title": "Curse of Decay",
    "traits": [
      "Curse",
      "Disease"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Attack -1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "If this is the first ability you have used this turn, destroy this card. You cannot use any more abilities this turn.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "If this is the first ability you have used this turn, destroy this card. You cannot use any more abilities this turn.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "curse-discord",
    "type": "curse",
    "subtype": null,
    "title": "Curse of Discord",
    "traits": [
      "Curse",
      "Disease"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Attack -1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Lose 2 gold to destroy this curse.",
          "repeatable": false
        }
      ],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "curse-horror",
    "type": "curse",
    "subtype": null,
    "title": "Curse of Horror",
    "traits": [
      "Curse",
      "Disease"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Attack -1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy this curse. Reduce your Light to 0. You cannot equip any more weapons, use any other Dungeon abilities, or use any other Trophy effects this turn.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "curse-hostility",
    "type": "curse",
    "subtype": null,
    "title": "Curse of Hostility",
    "traits": [
      "Curse",
      "Disease"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Attack -1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Discard 2 XP to destroy this curse.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Discard 2 XP to destroy this curse.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "curse-neglect",
    "type": "curse",
    "subtype": null,
    "title": "Curse of Neglect",
    "traits": [
      "Curse",
      "Disease"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Attack -1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Discard 2 cards to destroy this curse.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Discard 2 cards to destroy this curse.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "curse-shame",
    "type": "curse",
    "subtype": null,
    "title": "Curse of Shame",
    "traits": [
      "Curse",
      "Disease"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Attack -1",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Destroy this curse. Draw 2 fewer cards when you draw a new hand.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Destroy this curse. Draw 2 fewer cards when you draw a new hand.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "curse-sloth",
    "type": "curse",
    "subtype": null,
    "title": "Curse of Sloth",
    "traits": [
      "Curse",
      "Disease"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Attack -1",
          "repeatable": false
        }
      ],
      "village": [],
      "dungeon": [
        {
          "text": "Destroy this curse. Lower your Total Attack Value by 3. You cannot equip any more weapons, use any other Dungeon abilities, or use any other Trophy effects this turn.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "curse-war",
    "type": "curse",
    "subtype": null,
    "title": "Curse of War",
    "traits": [
      "Curse",
      "Disease"
    ],
    "xp": 0,
    "points": 0,
    "set": "CoB",
    "abilityText": {
      "alwaysActive": [
        {
          "text": "Attack -1",
          "repeatable": false
        },
        {
          "text": "You cannot rest or prepare.",
          "repeatable": false
        }
      ],
      "village": [
        {
          "text": "Select 2 random cards from your hand (excluding this card). You may destroy 1 of them to destroy this card.",
          "repeatable": false
        }
      ],
      "dungeon": [
        {
          "text": "Select 2 random cards from your hand (excluding this card). You may destroy 1 of them to destroy this card.",
          "repeatable": false
        }
      ],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    }
  },
  {
    "id": "familiar-battle-hawk",
    "type": "familiar",
    "subtype": null,
    "title": "Battle Hawk",
    "traits": [
      "Familiar"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "familiarAbilities": [
      {
        "xpCost": 0,
        "timing": "village",
        "text": "Gain 2 gold."
      },
      {
        "xpCost": 3,
        "timing": "dungeon",
        "text": "Light +1."
      },
      {
        "xpCost": 6,
        "timing": "dungeon",
        "text": "Draw 1 card. Physical Attack +1."
      }
    ]
  },
  {
    "id": "familiar-brownie",
    "type": "familiar",
    "subtype": null,
    "title": "Brownie",
    "traits": [
      "Familiar"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "familiarAbilities": [
      {
        "xpCost": 0,
        "timing": "village",
        "text": "Gain 1 gold and 1 additional buy."
      },
      {
        "xpCost": 3,
        "timing": "dungeon",
        "text": "Magic Attack +1."
      },
      {
        "xpCost": 6,
        "timing": "dungeon",
        "text": "Destroy 1 card to draw 1 card."
      }
    ]
  },
  {
    "id": "familiar-dire-wolf",
    "type": "familiar",
    "subtype": null,
    "title": "Dire Wolf",
    "traits": [
      "Familiar"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "familiarAbilities": [
      {
        "xpCost": 0,
        "timing": "village",
        "text": "Draw 1 card."
      },
      {
        "xpCost": 3,
        "timing": "dungeon",
        "text": "Physical Attack +1."
      },
      {
        "xpCost": 6,
        "timing": "dungeon",
        "text": "Switch the positions of any 2 monsters in the hall."
      }
    ]
  },
  {
    "id": "familiar-imp",
    "type": "familiar",
    "subtype": null,
    "title": "Imp",
    "traits": [
      "Familiar"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "familiarAbilities": [
      {
        "xpCost": 0,
        "timing": "village",
        "text": "Gain 1 XP."
      },
      {
        "xpCost": 3,
        "timing": "dungeon",
        "text": "Switch the positions of 2 adjacent monsters in the hall."
      },
      {
        "xpCost": 6,
        "timing": "dungeon",
        "text": "Discard 2 cards to draw 2 cards."
      }
    ]
  },
  {
    "id": "familiar-lesser-phoenix",
    "type": "familiar",
    "subtype": null,
    "title": "Lesser Phoenix",
    "traits": [
      "Familiar"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "familiarAbilities": [
      {
        "xpCost": 0,
        "timing": "village",
        "text": "Discard this card to gain 3 gold."
      },
      {
        "xpCost": 3,
        "timing": "dungeon",
        "text": "Discard this card to cancel 1 Battle effect."
      },
      {
        "xpCost": 6,
        "timing": "dungeon",
        "text": "Discard this card to draw 2 cards."
      }
    ]
  },
  {
    "id": "familiar-pseudodragon",
    "type": "familiar",
    "subtype": null,
    "title": "Pseudodragon",
    "traits": [
      "Familiar"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "familiarAbilities": [
      {
        "xpCost": 0,
        "timing": "village",
        "text": "You may buy 2 cards this turn."
      },
      {
        "xpCost": 3,
        "timing": "dungeon",
        "text": "Light +2."
      },
      {
        "xpCost": 6,
        "timing": "dungeon",
        "text": "Magic Attack +2."
      }
    ]
  },
  {
    "id": "familiar-shadow-cat",
    "type": "familiar",
    "subtype": null,
    "title": "Shadow Cat",
    "traits": [
      "Familiar"
    ],
    "xp": 0,
    "points": 0,
    "set": "ToR",
    "abilityText": {
      "alwaysActive": [],
      "village": [],
      "dungeon": [],
      "battle": [],
      "aftermath": [],
      "trophy": [],
      "trophyDungeon": [],
      "global": [],
      "react": [],
      "spoils": [],
      "breach": [],
      "raid": []
    },
    "familiarAbilities": [
      {
        "xpCost": 0,
        "timing": "village",
        "text": "Destroy a villager."
      },
      {
        "xpCost": 3,
        "timing": "dungeon",
        "text": "If there is Darkness, Physical Attack +2."
      },
      {
        "xpCost": 6,
        "timing": "dungeon",
        "text": "Cancel 1 Battle effect."
      }
    ]
  }
];

export const heroGroupKeys = [
  "aeon",
  "aird",
  "armsman",
  "bhoidwood",
  "blackhand",
  "blademage",
  "blind",
  "bluefire",
  "caliginite",
  "cathedral",
  "chalice",
  "charming",
  "clan",
  "clever",
  "criochan",
  "dark",
  "deepstrider",
  "disowned",
  "divine",
  "drua",
  "forcemage",
  "garrison",
  "glamercast",
  "gohlen",
  "graceful",
  "grim",
  "harruli",
  "honormain",
  "intelligent",
  "isri",
  "learned",
  "lorigg",
  "moonclaw",
  "mystic",
  "outlands",
  "patternmage",
  "profaned",
  "rapparee",
  "regian",
  "rugged",
  "silvertongue",
  "skinshifter",
  "spellsword",
  "stealthy",
  "sternnkin",
  "stoneguard",
  "strong",
  "strongwilled",
  "swift",
  "thornwood",
  "tholis",
  "thundermage",
  "tough",
  "tower",
  "tuath",
  "veilminder",
  "verdan",
  "veris",
  "whetmage",
  "wildwood",
  "woodfolk",
  "woodguard",
  "xenomorph"
];

export const monsterGroupKeys = [
  "abhuman",
  "abyssalElite",
  "abyssalMalformed",
  "abyssalThunderspawn",
  "ancientOnes",
  "automatons",
  "beasts",
  "bandit",
  "behemoth",
  "bestial",
  "burnmarked",
  "chiroptid",
  "corvaxis",
  "djinnbound",
  "djinni",
  "doomknightHumanoid",
  "doomknightUndead",
  "dragonChromatic",
  "dragonFire",
  "dragonHumanoid",
  "elementalEarth",
  "elementalPain",
  "elementalSalamander",
  "giant",
  "gnoll",
  "horrors",
  "incarnate",
  "infected",
  "kobold",
  "monstrosity",
  "ogre",
  "ooze",
  "oozeCavern",
  "royalGuard",
  "spider",
  "troll",
  "ultraterrestrial",
  "undeadDoom",
  "undeadLich",
  "undeadPlague",
  "undeadSkeleton",
  "undeadSpectral",
  "undeadSpirit",
  "undeadTreefolk",
  "verminous",
  "virulent",
  "worm"
];

export const hordeMonsterGroupKeys = [
  "abyssalHorde",
  "horde",
  "undeadHorde"
];

export const monsterGroupLevels = {
  "abhuman": 1,
  "abyssalElite": 2,
  "abyssalHorde": 1,
  "abyssalMalformed": 2,
  "abyssalThunderspawn": 1,
  "ancientOnes": 3,
  "automatons": 2,
  "beasts": 1,
  "bandit": 2,
  "behemoth": 3,
  "bestial": 1,
  "burnmarked": 2,
  "chiroptid": 1,
  "corvaxis": 2,
  "djinnbound": 1,
  "djinni": 3,
  "doomknightHumanoid": 2,
  "doomknightUndead": 3,
  "dragonChromatic": 3,
  "dragonFire": 3,
  "dragonHumanoid": 3,
  "elementalEarth": 3,
  "elementalPain": 3,
  "elementalSalamander": 2,
  "giant": 2,
  "gnoll": 2,
  "horde": 2,
  "horrors": 3,
  "incarnate": 3,
  "infected": 2,
  "kobold": 1,
  "monstrosity": 3,
  "ogre": 2,
  "ooze": 1,
  "oozeCavern": 1,
  "royalGuard": 2,
  "spider": 2,
  "troll": 2,
  "ultraterrestrial": 2,
  "undeadDoom": 1,
  "undeadHorde": 1,
  "undeadLich": 1,
  "undeadPlague": 2,
  "undeadSkeleton": 1,
  "undeadSpectral": 3,
  "undeadSpirit": 2,
  "undeadTreefolk": 3,
  "verminous": 1,
  "virulent": 2,
  "worm": 3
};
